
// tamilLanguage

export const tamilLanguage = {

    //home page -----------------------------------------------

    //app bar
    home_appBar: "முகப்பு", //"Home",
    aboutUs_appBar: "எம்மை பற்றி", //"About Us",
    news_appBar: "செய்திகள்", //"News",
    incidentMap_appBar: "சம்பவ வரைபடம்", //"Incidents Map",
    statistics_appBar: "புள்ளிவிவரம்", //"Statistics",
    howTo_appBar: "எவ்வாறு பயன்படுத்தலாம்?", //"How To",
    incidentReport_appBar: "அறிக்கைகள்/கதைகள்", //"Reports & Stories",

    //secure platform
    securePlatform_appBar: "பாதுகாப்பான அறிக்கை", //"Secure Reporting",
    securePlatform_badge: "பாதுகாப்பான தளம்", //"Secure Platform",
    securePlatform_title1: "புதிய அபேசல்லி பாதுகாப்பான", //"New Apesalli Secure",
    securePlatform_title2: "அறிக்கையிடல் தளம்", //"Reporting Platform",
    securePlatform_description: "உங்கள் அடையாளத்தைப் பாதுகாத்து, அநாமதேயமாக அறிக்கைகளை ​நேரடியாக TISL இற்கு  சமர்ப்பிக்கவும். உங்கள் அடையாளம் ​எப்போதும் பாதுகாக்கப்படும்.​​", //"Submit encrypted...",
    securePlatform_chip1: "Anonymous", //"Anonymous",
    securePlatform_chip2: "Encrypted", //"Encrypted",
    securePlatform_chip3: "Confidential", //"Confidential",
    securePlatform_cta: "Report Grand Corruption", //"Report Securely",

    //sub menu Report & Stories
    incident_appBar: "அறிக்கைகள்", //"Reports",
    story_appBar: "சம்பவங்கள்", //"Stories",

    //slide show
    mainTitle_SlideShow: "Apesalli.lk இணையதளத்தை எவ்வாறு பயன்படுத்தலாம்", //"How To Use ApeSalli.lk",
    mainTopTitle_SlideShow: "பயன்படுத்துவது எப்படி", //"How To Use",
    mainDescription_SlideShow: "இணையதளத்தை எவ்வாறு பயன்படுத்தலாம்", //"Watch Video and Learn More About Apesalli and How to Lodge Complain",

    //button titles
    incidentReportButtonTitle_Story: "நீங்கள் அவதானித்த விடயத்தை எமக்கு அறிவியுங்கள்",//"If You See Something, Say Something",
    incidentReportButtonTitle_Corruption: "வார்த்தைகள் இதயத்தை தொடுகின்றது, இதயம் அதனை செயற்படுத்துகின்றது",//"Words Move Hearts, Hearts move Limbs",
    incidentReportButtonTitle_Election: "தேர்தல் சட்ட மீறல்கள்",//"Election Violations",

    //button descriptions
    // incidentReportButtonDescription_Story: "Share Your Experience and Views on Bribery and Corruption",
    // incidentReportButtonDescription_Corruption: "Report Incidents of Bribery and Corruption to TISL",
    // incidentReportButtonDescription_Election: "If You See Violations, Report Election Violations to TISL",
    incidentReportButtonDescription_Story: "இலஞ்சம் மற்றும் ஊழல் தொடர்பான சம்பவங்களை TISL இற்கு முறையிடுங்கள்",//"Report Incidents of Bribery and Corruption to TISL",
    incidentReportButtonDescription_Corruption: "இலஞ்சம் மற்றும் ஊழல் பற்றிய உங்களது கருத்துக்கள் மற்றும் அனுபவங்களை பரிமாறிக்கொள்ளுங்கள்",//"Share Your Experience and Views on Bribery and Corruption",
    incidentReportButtonDescription_Election: "தேர்தல் சட்ட மீறல்களை TISL இற்கு அறிவியுங்கள்",//"Report Election Violations to TISL",

    //Read more Button
    readMoreButton: "மேலும் வாசிக்க...", //"Read More...",
    viewMoreButton: "மேலும் பார்க்க...", //"View More...",

    //Read more Reports Button
    readMoreReportsButton: "மேலும் பல அறிக்கைகளை வாசிக்க..", //"Read More Reports...",

    //Read more News Button
    readMoreNewsButton: "மேலும் பல செய்திகளை வாசிக்க...", //"Read More News...",

    //titles
    incidents_title: "சம்பவங்கள்", //"Incidents",

    //Footer -----------------------------------------------
    footer_addressColomboTitle: "கொழும்பு அலுவலகம்", //"Colombo Office",
    footer_addressColomboDescription: "இல.366, நாவலை வீதி,  நாவலை, ராஜகிரிய ",

    footer_addressPhoneName: "தொலைபேசி​:", //"Phone:",
    footer_addressColomboPhoneValue: " (+94) 0114369781 | 0114369782 | 0114369783",

    footer_addressFaxName: "தொலைநகல்:", //"Fax:",
    footer_addressColomboFaxValue: " (+94) 0112865777",

    footer_addressEmailName: "மின்னஞ்சல்:", //"Email:",
    footer_addressColomboEmailValue: " tisl@tisrilanka.org",

    footer_addressWebName: "வலைத்தளம்:", //"Web:",
    footer_addressColomboWebValue: "www.tisrilanka.org",
    footer_addressColomboWebHrefValue: "https://www.tisrilanka.org",

    footer_addressMataraTitle: "மாத்தறை அலுவலகம்", //"Matara Office",
    footer_addressMataraDescription: "17, காளிதாஸ் வீதி, மாத்தறை", //"17, Kalidasa Road, Matara",

    footer_addressMataraPhoneValue: " (+94) 041 22 33 522",

    footer_addressMataraEmailValue: " alac-matara@tisrilanka.org",

    footer_addressVavuniyaTitle: "வவுனியா அலுவலகம்", //"Vavuniya Office",
    footer_addressVavuniyaDescription: "SLRCS கட்டிடம், ஓப்  பார்க் வீதி, வவுனியா.",
    //"SLRCS Building , Off Park Road , Vavuniya",

    footer_addressVavuniyaPhoneValue: " (+94) 024 222 76 76",
    footer_addressVavuniyaEmailValue: " alac-vavuniya@tisrilanka.org",

    footer_disclaimer_btn: "பொறுப்பு துறப்பு", //"Disclaimer",
    footer_privacyPolicy_btn: "தனித்துவத்தை பாதுகாப்பதற்கான கொள்கை", //"Privacy Policy",

    //Disclaimer -----------------------------------------------
    disclaimer_mainTitle: "பொறுப்பு துறப்பு", //"Disclaimer",
    disclaimer_descriptionP1: "இவ்வலைத்தளத்தில் உள்ளடக்கப்பட்டிருக்கும் தகவல்கள் பொது தேவைகளுக்காக மட்டுமேயாகும். மேலும் இத்தகவல் பொது மக்களால் வழங்கப்பட்டதாகும். குறிப்பிடப்பட்டுள்ள தகவல்களின் உறுதித்தன்மை, நம்பகத்தன்மை பொருந்தும்தன்மை போன்றவற்றிற்கு நாம் பொறுப்பேற்க மாட்டோம். நீங்கள் வலைத்தளத்தில் கூறப்பட்டுள்ள தகவல்களை நம்பிக்கை கொள்வது உங்கள் தனிப்பட்ட அவதானத்திலேயாகும்.",
    //"The information contained on this website is for general information purposes only. The information is provided by the general public and while we endeavor to keep the information up to date and correct, we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability or availability with respect to the website or the information or related graphics contained on the website for any purpose. Any reliance you place on such information is therefore strictly at your own risk.",
    disclaimer_descriptionP2: "ட்ரான்ஸ்பேரன்சி இன்டர்நெஷனல் ஸ்ரீ லங்கா இவ்வலைத்தளத்தில் கூறப்பட்ட தகவல்கள் வெளியிடப்பட்ட நேரத்தில் உண்மையானது எனவும் சரியாக வெளியிடவும் முயற்சிகள் எடுக்கும் சந்தர்ப்பத்தில் தகவல்களின் சரியான தன்மைக்கும் நம்பகத்தன்மைக்கும் பூரணத்தன்மைக்கும் பொறுப்பேற்காது. அதேபோல் இணையதளத்தை பிரவேசிக்கும் பயனர்கள் அல்லது மூன்றாம் தரப்பினரால் ஏற்படும் நேரடி அல்லது மறைமுக இழப்புகளுக்கும் எந்த பொறுப்பையும் TISL ஏற்காது என்பதை கவனத்தில் கொள்ளவும்.",
    //"Transparency International Sri Lanka makes all reasonable efforts to ensure that the information presented on this website is accurate at the time it is published, but accepts no liability whatsoever for its correctness, reliability, topicality or completeness. Transparency International Sri Lanka assumes no responsibility for any direct or indirect loss suffered by users or third parties in connection with the use of the website.",
    disclaimer_descriptionP3: "மேலும் சமர்ப்பிக்கப்பட்ட முறைப்பாடுகளை நன்கு விசாரித்த பின் மாத்திரமே ஏதும் நடவடிக்கை எடுக்க வெண்டுமெனில் மாத்திரமே சட்ட ரீதியாக நடவடிக்கை எடுக்கும். வலைத்தளத்திற்கு சமர்ப்பிக்கப்படும் முறைப்பாடுகளுக்கு நடவடிக்கை எடுக்காத பட்சத்தில் அதற்கும் பொறுப்பேற்காது. எவ்வாறாயினும் இணையதளத்தில் சமர்பிக்கப்பட்டுள்ள கதைகள் அல்லது அறிக்கைகள் சம்பந்தமான விடயங்கள் தொடர்பில் நடவடிக்கை மேற்கொள்ளாமல் இருப்பதற்கும் உரிமை கொண்டுள்ளது.",
    //"Transparency International Sri Lanka will only take legal or other necessary action based on complaints/ stories submitted by users after a thorough follow-up and verification of the complaint, and if it is deemed that there is a viable cause of action. Transparency International Sri Lanka takes no responsibility for, and will not be liable for, not taking any action in relation to submissions made to the website. Transparency International Sri Lanka reserves the right to not take action based on submissions made to the website. Transparency International Sri Lanka takes no responsibility for, and will not be liable for, any delays on the part of government authorities in taking action against any complaint.",
    disclaimer_descriptionP4: "மேலும் ட்ரான்ஸ்பேரன்சி இன்டர்நெஷனல் ஸ்ரீ லங்கா அரசினால் சட்ட ரீதியாக நடவடிக்கை எடுக்க தாமதமாகும் சந்தர்ப்பத்தில் அதற்கும் பொறுப்பேற்காது. ஒவ்வொரு முயற்சியும் வலைத்தளத்தை கணிசமாக முன்னெடுக்கவே மேற்கொள்ளப்படுகிறது. நமது கட்டுப்பாட்டிட்குள்ளடங்காத சட்ட ரீதியாக ஏற்படும் பிரச்சினைகளுக்கும் வலைத்தளத்தை பாவிக்க முடியமால் போகும் சந்தர்ப்பத்திற்கும் பொறுப்புக்கூறாது.",
    //"Every effort is made to keep the website up and running smoothly. However, Transparency International Sri Lanka takes no responsibility for, and will not be liable for, the website being temporarily unavailable due to technical issues beyond our control.",
    disclaimer_descriptionP5: "இவ்வலைத்தளத்தினூடாக நீங்கள் வேறு வலைத்தளமொன்றிற்கு இணைப்பை ஏற்படுத்தலாம் அவ்வாறு ஏற்படுத்தும் பொது அந்த சந்தர்ப்பத்தில் ட்ரான்ஸ்பேரன்சி இன்டர்நெஷனல் ஸ்ரீ லங்கா பொறுப்பு கூறாது. மேலும் வலைத்தளத்தின் தன்மை உள்ளடக்கம், போன்றவற்றிற்கு ட்ரான்ஸ்பேரன்சி இன்டர்நெஷனல் ஸ்ரீ லங்கா பொறுப்பேற்காது. உள்ளடக்கப்பட்டிருக்கும் இணைப்புகள் தெரிவிக்கப்பட்டுள்ள கருத்துக்களை பரிந்துரை செய்யாது. ட்ரான்ஸ்பேரன்சி இன்டர்நெஷனல் ஸ்ரீ லங்கா என்பது அரசாங்க நிறுவனமோ சட்ட அமுலாக்க நிறுவனமோ அல்ல.",
    //"Through this website you may be able to link to other websites which are not under the control of Transparency International Sri Lanka. We have no control over the nature, content and availability of those websites. The inclusion of any links does not necessarily imply a recommendation or an endorsement of the views expressed within them. Transparency Sri Lanka is neither a governmental nor law enforcement agency.",

    //FAQ page -----------------------------------------------

    //Title
    faq_mainTitle: "அடிக்கடி கேட்கப்படும் கேள்விகள்", //"FAQs",

    //Video Section - body 1
    faq_subTitle: "இத்தளத்தை எவ்வாறு பயன்படுத்தலாம்", //"How to use ApeSalli.lk",
    // faq_description: "Watch Video and Learn More About Apesalli and How to Lodge Complain",

    //body 2
    faq_question1: "1. இத்தளத்தின் செயற்பாடுகள் என்ன?", //"1.	What does this website do?",
    faq_q1Answer: "ஊழலுக்கு எதிராக செயற்படக்கூடிய ஒரு களமாக Apesalli.lk விளங்குகிறது. ஊழல் மற்றும் இலஞ்சம் தொடர்பான சம்பவங்களை நீங்கள் இங்கு முறையிடலாம்.  மேலும் அரச மற்றும் தனியார் துறைகளில் நடைபெறுகின்ற ஊழல் மற்றும் இலஞ்சம் தொடர்பான உங்களது அனுபவங்களையும் பகிர்ந்துகொள்ளலாம். Apesalli.lk இணையத்தளமானது இலங்கையில் ஊழலுக்கு எதிராக செயற்படும் ஓர் தளமாகும்.",
    //"Apesalli.lk is an exposure and discussion platform for all things on anti-corruption. You can report incidents of bribery and corruption and also share your experiences on bribery and corruption in government, private or civil society sector using Apesalli.lk. This is a platform for both activism and advocacy on anti-corruption in Sri Lanka.",

    faq_question2: "2. நான் ஏன் ஆர்வமாக செயற்பட வேண்டும்?", //"2.   Why should I be interested?",
    faq_q2AnswerPara1: "நம் சமூகத்தில் ஊழல் மற்றும் இலஞ்சமானது ஒர் சாதாரண செயலாக மாறி நம்மில் அநேகமானோர் அதை கண்டுகொள்ளாமல் இருக்கின்றனர். அவ்வாறான மோசமான செயலை இல்லாதொழிக்க நாம் முன்நிற்க வேண்டும். அவ்வாறான ஒரு திட்டத்தையே Apesalli.lk செய்து வருகிறது.",
    // "Bribery and corruption have become a norm in our society and most of us turn a blind eye to it. This vicious cycle can only be broken by taking a stand against this very problem and apesalli.lk gives Sri Lankans an opportunity to do just that.",
    faq_q2AnswerPara2: "அநேகமானோர் இத்தகைய செயற்பாடுகளுக்காக தமது நேரங்களை ஒதுக்க முடியாமல் இருப்பதனால் இத்தளமானது உங்களது வேலையை இலகுவாக்கி செய்தியை பரப்பவும் உதவுகிறது.",
    // "We know that everyone leads a busy lifestyle, and taking a stand on a cause might consume time that you do not have to spare! This platform simplifies the process of taking a stand against bribery and corruption. Report an incident or share your story, and the platform will help propagate the message and on possible occasions, take action on behalf of you.",

    faq_question3: "3. இங்கு நான் ஓர் சம்பவம் தொடர்பாக முறையிட்டால், எவ்வாறான நடவடிக்கைகள் மேற்கொள்ளப்படும்?",
    //"3.	What steps are taken if I report an incident?",
    faq_q3AnswerPart1: "நாம்,", //"We will,",
    faq_q3AnswerPart2: "- கிடைக்கப்பெற்ற முறைப்பாடு தொடர்பான ஆரம்பக்கட்ட தகவல் திரட்டல்களை மேற்கொள்வோம்.", //"- Conduct an initial filtering of complaints received",
    faq_q3AnswerPart3: "- அதைப்பின் குறித்த சம்பவம் தொடர்பான உண்மைத் தன்மை மற்றும் திரட்டப்பட்ட தரவுகளை சுதந்திரமாக சரி பார்ப்போம்.", //"- Independently verify the facts of the reported incident",
    faq_q3AnswerPart4: "- தேவைப்படின் மேலதிக சாட்சிகளை திரட்டுவோம்.", //"- Collect more evidence if necessary",
    faq_q3AnswerPart5: "- முறைப்பாடு செய்தவருக்கு தனது முறைப்பாட்டை முறையாக சமர்ப்பிக்க உதவி செய்தல் அல்லது குறித்த முறைப்பாட்டினை உரிய அதிகாரிகளுக்கு நேரடியாக நாம் சமர்ப்பித்தல் போன்ற நடவடிக்கைகள் மேற்கொள்வோம்.",
    //"- Assist the complainant to submit the complaint or directly submit the complaint to the relevant authorities",

    faq_question4: "4. எனது அனுபவங்களை நான் பகிரும் போது என்ன நடக்கும்?",
    //"4.	What happens when I share my experience?",
    faq_q4Answer: "நாம் உங்களது கதைகளை பல இலட்சம் மக்கள் வாசித்து மற்றவர்களுடன் பகிர்ந்து கொள்ளும் வண்ணம் TISL இணையதளத்திலும் சமூக வலைத்தளங்களிலும் பகிர்வோம். கிடைக்கப்பெறும் தகவல்களின் அடிப்படையில் கதையினை பகிர்ந்து கொண்ட நபரின் அனுமதியுடன் சட்ட ரீதியான நடவடிக்கைகளையும் மேற்கொள்வோம்.",
    //"We may post the story on the TISL’s website and/or social media for millions of other people to read, share and inspire. We may take necessary legal action based on the stories, after informing the submitter and based on the availability of information.",

    faq_question5: "5. இலஞ்சம் மற்றும் ஊழல் தொடர்பான எனது அனுபவத்தினூடாக எவ்வாறான மாற்றத்தினை ஏற்படுத்தலாம்?",
    //"5.	What difference I can make if I share my experience on bribery and corruption?",
    faq_q5Answer: "உங்களது அனுபவத்தினை பகிர்ந்து கொள்வதன் மூலம் ஏனையோரும் அவர்களது அனுபவங்களை பகிர்ந்துகொள்ள முன்வருவர். மேலும், ஊழலுக்கான அடிப்படை காரணிகளை கண்டறிய இது எங்களுக்கு உதவும். முக்கியமாக, உங்களது அனுபவம் மிக சிறியது அல்லது தாக்கம் குறைவானது என நீங்கள் கருதினாலும் அது ஊழலுக்கு எதிரான செயற்பாட்டிற்கு மேலும் வலு சேர்க்கும்.",
    //"Sharing your experience will inspire and motivate others to share their stories as "well. Also, it will help us find corruption trends and hotspots. Most importantly sharing your story, no matter how small you think it is, will contribute to the fight against corruption!",

    faq_question6: "6. உங்களால் எவ்வாறான ஊழல்களை அறிக்கையிட முடியும்?",
    // "6. What are the types of corruption you can report?",

    // faq_q6AnswerP1Title: "இலஞ்சம்  - ", //"Bribery",
    // faq_q6AnswerP1Description: "கொடுப்பனவு, வாக்குறுதி, கொடுத்தல் மற்றும் ஏற்றுக்கொள்ளல் அல்லது நன்மை /பயன் கருதி எதிர்பார்த்தால் அல்லது முறையற்ற, சட்ட விரோதமான, நம்பத்தகாத பரிசாக, கடனாக, கட்டணமாக, கொடுப்பனவாக கொடுத்தல்.[வரிகள், சேவைகள், கொடுப்பனவுகள்,] [மொழி வழிகாட்டி]",
    // // "The offering, promising, giving, accepting or soliciting of an advantage as an inducement for an action which is illegal, unethical or a breach of trust. Inducements can take the form of gifts, loans, fees, rewards or other advantages (taxes, services, donations, etc.)  The bribe could be in the form of appointment, cash, commission, valuable security, property or interest in property, failure to take action, favor, fee, gift, loan, promise, reward and service.",

    // faq_q6AnswerP2Title: "பாலியல் ரீதியான உதவிகள் - ", //"Sexual favors "
    // faq_q6AnswerP2Description: "ஒரு தனி நபர் பொது சட்ட மற்றும் சமாதான அல்லது போலீஸ் சேவைகளுக்காக செல்லுமிடத்து அவர் பாலியல் ரீதியாக உதவுமாறு நிர்ப்பந்திக்கப்படல்.[சியாமளா கொமஸ் அவர்களின் பதிவு ]",
    // // "When an individual who goes to a public, judicial, peace or police officer for a public service is required to perform a sexual favour in return for the service that they are entitled to by the law.",

    // faq_q6AnswerP3Title: "பொது நிதியையும் சொத்துக்களையும் தவறாக பயன்படுத்துதல் - ", //"Misuse of Public Funds or Property",
    // faq_q6AnswerP3Description: "அதிகாரமிருக்கும் உத்தியோகத்தர் தனது சொந்த தேவைகளுக்காக பொது நிதியையும் சொத்துக்களையும் பயன்படுத்தல்.",
    // // "When a person holding office in an institution, organization or company dishonestly and illegally appropriates, uses or traffics the funds and goods they have been entrusted with for personal enrichment or other activities. ",

    // faq_q6AnswerP4Title: "பொதுப்பதவிகளை தவறாக பயன்படுத்தல் - ", 
    // //"Misuse of Public Property(Movable/Immovable) -",
    // // "Misuse of Public Position  - ",
    // faq_q6AnswerP4Description: "ஒரு நிறுவனம், அமைப்பு அல்லது நிறுவனத்தில் பதவியில் இருப்பவர் நேர்மையற்றதாகவும் சட்டவிரோதமாகவும் தனிப்பட்ட செறிவூட்டல் அல்லது பிற நடவடிக்கைகளுக்காக அவர்கள் ஒப்படைத்துள்ள நிதி மற்றும் பொருட்களை பயன்படுத்துதல்.[வரைவிலக்கணம் - நெறிமுறைகள் மற்றும் ஊழல் எதிர்ப்பு ஆணைக்குழு, கென்யா]", 
    // //"Misuse of any movable or immovable property in every description that are vested in and maintained by the State and used for the purposes of the State. Types of public property are land, buildings, vehicle equipment or other facilities or human resources.",
    // // "A person who uses his office to improperly benefit oneself or another person.",

    // faq_q6AnswerP5Title: "எண்ணங்களில் மோதல்  - ", 
    // // "Conflict of Interest - ",
    // faq_q6AnswerP5Description: "ஒரு தனி நபரின் விருப்புகளும் கோரிக்கைகளும் ஒரு அரச தொழில் சார்ந்த மற்றும் ஊடகமாக அவரின் கடமைகளையும் கோரிக்கைகளையும் எதிர்கொள்கிறது.", 
    // // "Situation where an individual or the entity for which they work, whether a government, business, media outlet or civil society organization, is confronted with choosing between the duties and demands of their position and their own private interests. The interest could be in the nature of self-dealing, outside employment, family interests and gifts.",

    // faq_q6AnswerP6Title: "பொது கொள்முதல் முறைகேடுகள் - ", 
    // //"Public Procurement Irregularities  - ",
    // faq_q6AnswerP6Description: "சாமான்களை பெற்றுக்கொள்ளும் வழிகளில் வரும் முறைகேடுகள் [வரைவிலக்கணம் - நெறிமுறைகள் மற்றும் ஊழல் எதிர்ப்பு ஆணைக்குழு, கென்யா]", 
    // // "Any irregularities in multi-step process of established procedures to acquire goods and services by any individual, company or organization — from the initial needs assessment to the contract’s award and service delivery. The irregularity could be absence of open tendering, collusion, conflict of interest or lack of qualification.",

    // faq_q6AnswerP7Title: "மற்றவை - ", 
    // //Other
    // faq_q6AnswerP7Description: "மற்றவை", 
    // //Other

    faq_q6AnswerP8Title: "",
    faq_q6AnswerP8Description: "",

    faq_question7: "7.	 எனது தனிப்பட்ட தகவல்களை நான் ஏன் வெளிப்படுத்த வேண்டும்?",
    faq_q7Answer: "உங்களது தனிப்பட்ட தகவல்களை பகிர்ந்து கொள்ளாமலே உங்களது முறைப்பாடு மற்றும் கதைகளை பகிர்ந்து கொள்ளலாம். இருப்பினும், உங்களது தனிப்பட்ட தகவல்கள் வெளியிடப்பட்டிருந்தால் குறித்த சம்பவம் தொடர்பான தகவல்களை சரி பார்ப்பதற்கும் உங்களுக்கு சம்பவம் தொடர்பாக உதவுவதற்கும் அதனை பின் தொடர்வதற்கும் எளிதாக அமையும்.",
    //About US page -----------------------------------------------

    //title
    aboutUs_Title: "எம்மை பற்றி", //"About Us",

    //description
    aboutUs_description1: "அரசியல், பொது, தனியார் மற்றும் சமூக வளர்ச்சியில் வேரூன்றி காணப்படும் ஊழல் மற்றும் இலஞ்சம் என்பன இலங்கையின் அபிவிருத்திக்கு தடையாக காணப்படுகின்றன. காலம் காலமாக நம்மில் அநேகர் இவ்வாறான செயல்களுக்கு எதிராக குரல் கொடுப்பதையும் மேலும் அவ்வாறு நடக்கும் அநியாயங்களுக்கு அமைதி காத்து வருவதையும் நாம் அறிவோம். பொதுமக்கள் இலஞ்சம் மற்றும் ஊழல் தொடர்பான தமது கதைகளை மற்றும் சம்பவங்களை வெளிப்படுத்தவும் அது தொடர்பில் முறைப்பாட்டினை மேற்கொள்வதற்கான வாய்ப்பினையும் ஏற்படுத்தும் நோக்கிலேயே Apesalli.lk தளமானது உருவாக்கப்பட்டுள்ளது. இத்தளமானது இலஞ்சம் மற்றும் ஊழல் தொடர்பான ஓர் பரந்த கலந்துரையாடலை உருவாக்க முனைவதுடன் குறித்த பிரச்சினைகள் தொடர்பான முக்கிய விடயங்களை ஆழமாக அடையாளப்படுத்தவும் இவ்வாறான செயற்பாடுகளுக்கு எதிராக செயற்படுவோரை வெளிப்படுத்துவதையும் நோக்காகக் கொண்டுள்ளது.", //"Deep rooted and pervasive corruption, in the political, public, private and civil society sectors has been a persistent obstacle to the development of Sri Lanka.",

    aboutUs_description2: "அரசியல், பொது, தனியார் மற்றும் சமூக வளர்ச்சியில் வேரூன்றி காணப்படும் ஊழல் மற்றும் இலஞ்சம் என்பன இலங்கையின் அபிவிருத்திக்கு தடையாக காணப்படுகின்றன. காலம் காலமாக நம்மில் அநேகர் இவ்வாறான செயல்களுக்கு எதிராக குரல் கொடுப்பதையும் மேலும் அவ்வாறு நடக்கும் அநியாயங்களுக்கு அமைதி காத்து வருவதையும் நாம் அறிவோம். பொதுமக்கள் இலஞ்சம் மற்றும் ஊழல் தொடர்பான தமது கதைகளை மற்றும் சம்பவங்களை வெளிப்படுத்தவும் அது தொடர்பில் முறைப்பாட்டினை மேற்கொள்வதற்கான வாய்ப்பினையும் ஏற்படுத்தும் நோக்கிலேயே Apesalli.lk தளமானது உருவாக்கப்பட்டுள்ளது. இத்தளமானது இலஞ்சம் மற்றும் ஊழல் தொடர்பான ஓர் பரந்த கலந்துரையாடலை உருவாக்க முனைவதுடன் குறித்த பிரச்சினைகள் தொடர்பான முக்கிய விடயங்களை ஆழமாக அடையாளப்படுத்தவும் இவ்வாறான செயற்பாடுகளுக்கு எதிராக செயற்படுவோரை வெளிப்படுத்துவதையும் நோக்காகக் கொண்டுள்ளது. Apesalli.lk தளமானது ஊழலுக்கு எதிராக செயற்படும் நோக்குடன் ட்ரான்ஸ்பேரன்சி இன்டர்நெஷனல் ஸ்ரீ லங்கா (TISL) இனால் உருவாக்கப்பட்டது. ட்ரான்ஸ்பேரன்சி இன்டர்நெஷனல் ஸ்ரீ லங்கா (TISL) நிறுவனமானது ஊழலுக்கு எதிரான செயற்படும் ட்ரான்ஸ்பேரன்சி இன்டர்நெஷனல் (TI) சர்வதேச நிறுவனத்தின் உள்நாட்டு அமைப்பாகும். TISL நிறுவனமானது இலங்கையில் நடைபெறுகின்ற ஊழலுக்கு எதிராகவும் நல்லாட்சியை ஊக்குவிப்பதற்கும் உறுதிபூண்டுள்ளதுடன் எதிர்கால இலங்கையை சமாதான நல்லாட்சியை நிலவ மற்றும் ஊழலை இல்லாதொழிக்க மேற்கொள்ளப்படும் ஒன்றினைந்த கூட்டு முயற்சிக்கு ஆதரவு வழங்குவது TISL நிறுவனத்தின் நோக்காகும்.", //"Over the years there have been many members of the public who have taken a stand against corruption and bribery or simply borne its burden in silence. Apesalli.lk was created with the objective of giving the public an opportunity to report and share their stories on incidents of corruption and bribery. By shedding a light on these illicit activities, Apesalli.lk aims to create a broader discourse on corruption and bribery, capture the popular narrative on the issue, as well as highlight those who wish to take a stand against such acts.",
    aboutUs_description3: "", //"Apesalli.lk is powered by TISL’s mandate on anti-corruption. Transparency International Sri Lanka (TISL) is the local chapter of the global movement against corruption, committed to promoting good governance and eradicating corruption in Sri Lanka. TISL’s mission is to support the collective effort to eradicate corruption in order to build a future Sri Lanka which is equitable, peaceful, and just.",

    //Privacy Policy page -----------------------------------------------

    //title
    privacyPolicy_Title: "தனித்துவத்தை பாதுகாப்பதற்கான கொள்கை", //"Privacy Policy",

    //Descriptions
    privacyPolicy_Description1: "இவ்வலைத்தளமானது உங்கள் கதைகளை அல்லது முறைப்பாடுகளை பதிய முடியுமான ஒரு களமாக விளங்குகிறது. மேலும் நாம் Apesalli.lk ஊடாக பல வகையான கருத்துகளையும் வரவேற்கும் சந்தர்ப்பத்தில் உங்களுக்கு கட்டுக்கோப்பான தரவுகளை பதியுமாறும் வேண்டிக்கொள்கிறோம்.",
    //"This website is a platform for you to post your stories or to submit your complaints. Whilst we, at Apesalli.lk, welcome all viewpoints, we request you to submit constructive input.",

    privacyPolicy_Description2: "பயனர்கள் தாங்கள் பதிவு செய்யும் அனைத்திற்கும் பொறுப்பு மிக்கவராக கருதப்படும் சந்தர்ப்பத்தில் வலைத்தளம் எந்த விதமான பயனர்கள் பதிவு செய்த பதிவுகளுக்கும் பொறுப்பேற்காது. தயவுசெய்து பிழையான மற்றும் போலியான கதைகளையோ இழிவான, குற்றம் சுமத்த கூடிய அச்சுறுத்தக்கூடிய தீங்கு விளைவிக்கக்கூடிய மோசமான பதிவுகளையோ பதிவு செய்யாதீர்கள்.",
    //"Users are responsible for all content posted by them and the website shall not be responsible for the accuracy or legality of any material posted by users on this website. Please do not report incidents or submit stories that are false, defamatory, abusive, threatening, harmful, obscene, or profane.",
    privacyPolicy_Description3: "இவ்வலைத்தளத்தை பயன்படுத்துமிடத்து நீங்கள் தனியுரிமைக் கொள்கையில் கூறப்பட்ட அனைத்து தரவு சேர்க்கும் முறைகளுக்கும் அவற்றினை பயன்படுத்தவும் உடன்படுகிறீர்கள். இத்தனியுரிமைக் கொள்கையை நங்கள் எவ்வாறு உங்கள் தனிப்பட்ட தரவுகளை அணுகுகிறோம் மற்றும் எவ்வாறு தனியுரிமையைப் பாதுகாக்கிறோம் என Apesalli.lk பவிப்பதன் ஊடாக தெரிவிக்கிறோம். Apesalli.lk அல்லது எமது பிற திட்டங்களின் நோக்கங்களை அடைந்துக்கொள்ள அல்லது மேம்படுத்த உங்களது தனிப்பட்ட தகவல்கள் பயன்படுத்தப்படுமே தவிர வேறு எந்த நோக்கத்திற்காகவும் உங்களது தனிப்பட்ட தகவல்களை சேகரிக்கவோ, பயன்படுத்தவோ அல்லது வெளியிடவோ மாட்டோம்.",
    //"By using this website, you consent to our collection and use of information relating to your use of the website as described in this Privacy Policy. This privacy policy explains how we treat your personal data and protect your privacy when you use Apesalli.lk. We do not collect, use or disclose your personal information for any purpose other than as detailed below, to further or promote the objectives of Apesalli.lk or our other projects.",
    privacyPolicy_Description4: "எமது வளையத்தளத்தின் பார்வையாளரான உங்களின் தனியுரிமையை பாதுகாக்க நாம் கடமைப்பட்டுள்ளோம் மற்றும் உங்களது தகவலின் தனியுரிமை மற்றும் பாதுகாப்பினை உறுதிப்படுத்த அர்ப்பணிப்புடன் செயற்படுகின்றோம்.",
    //"We are committed to protecting your privacy as a visitor to our website and take the privacy and security of your information very seriously.",

    privacyPolicy_subTitle1: "1. தகவல் திரட்டு", //"1. INFORMATION COLLECTION:",
    privacyPolicy_subTitle1Description: "வலைத்தளத்தில் நுழையும் போது நீங்கள் இருவகையான தகவல்களை முன் வைக்கலாம். (அ) நீங்கள் அறிந்து பரிமாற விரும்பும் தகவல். (ஆ) இணையதள பயன்பாட்டு ரீதியாக மதிப்பீட்டு  ரீதியில் கிடைக்கப்பெறும் தகவல்கள்.",
    //"When you visit the site, you may provide two types of information: (a) personal information that you knowingly choose to disclose, and which is collected on an individual basis; and (b) website use information collected on an aggregate basis as you and other users browse the website.",

    privacyPolicy_subTitle1P1: "1.1 தனிப்பட்ட தகவல்", //"1.1. Personal Information",
    privacyPolicy_subTitle1P1DescriptionP1: "தனிப்பட்ட ரீதியான தகவல்கள் பின்வரும் விடயங்கள் உள்ளடங்கலாக அமையப்பெறும்; பெயர், முகவரி, மின்னஞ்சல் முகவரி தொலைபேசி இலக்கம், வயது மற்றும் பால்நிலை போன்றவையாகும். உங்களுக்கு அறிக்கைகளை சமர்ப்பிக்கலாம், தேடல் மற்றும் தகவல்களை மேற்கொள்ளலாம். மேலும் இணையயத்தளத்தின் புதுமையான மற்றும் தரமான சேவைகளை பயன்படுத்தி தகவல்களை பரிமாற்றம் செய்துகொள்ளலாம். நீங்கள் ஒரு அறிக்கை அல்லது முறைப்பாட்டை சமர்ப்பிக்கும் போது அல்லது உங்களது கதையினை பகிரும் பொது மற்றும் பொதுவில் நீங்கள் பகிர்ந்து கொள்ள தெரிவு செய்யும் தகவல்கள் போன்றவை உங்களை பற்றி பல தகவல்களை பெற்றுக்கொள்ள வழிவகுக்கின்றன.",
    //"Personal information about an individual may include the following: Name, Address, Email, Phone number, Age, Gender. You may post reports, perform searches and queries, share and transmit information and use the interactive features of the website. In doing this we receive different types of information about you including information that is required when you submit a report/complaint or share your stories, as well as personal information that you may choose to share publicly.",
    privacyPolicy_subTitle1P1DescriptionP2: "நீங்கள் உங்கள் தனிப்பட்ட தகவல்களை சமர்ப்பிக்க தேர்ந்தெடுப்பதன் மூலம் தங்கள் TISL இற்கு சமர்ப்பிக்கப்பட்ட முறைப்பாடு தொடர்பான மேலதிக உண்மைகளை கண்டறிய மற்றும் மேலதிக தகவல்களை பெறத் தேவைப்பட்டால் உங்களை அணுகவும் அனுமதி வழங்குகிறீர்கள். உங்கள் அனுமதியின்றி தனிப்பட்ட தகவல்கள் வலைத்தள இடைமுகத்தில் காண்பிக்கப்படமாட்டாது. சட்ட நடவடிக்கைகளுக்காக அன்றி மூன்றாம் தரப்பினர்களுக்கு தனிப்பட்ட தகவல்கள் வெளிப்படையான அனுமதியின்றி வழங்கப்பட மாட்டாது.",
    //"By choosing to submit your personal information, you are giving TISL permission to the use said personal information for further fact finding pertaining to the complaint/story submitted and to contact you if required to obtain further information. The personal information submitted will not be displayed on the website interface without your express consent. Personal information will not be submitted to third parties without express consent or in an anonymized or aggregated manner, unless it is with regard to a legal action.",

    privacyPolicy_subTitle1P2: "1.2 ஜியோ டெக்கிங் இருப்பிடத் தகவல்", //"1.2. Geo-tagging location information",
    privacyPolicy_subTitle1P2Description: "நீங்கள் இலஞ்சம் அல்லது ஊழல் நடந்தகாக கூறப்படும் சம்பவத்தின் இருப்பிடத்தை சமர்ப்பிக்கும் போது இவ்வலைத்தளம் புவிக்குறிச் சொல்லைப் பயன்படுத்தி இலஞ்சம் அல்லது ஊழல் நடந்தாக அறியப்படும் இடத்தினை அண்ணளவாக வலைத்தள தேசப்படத்தில் காட்சிப்படுத்தும். மேலும் இருப்பிட தகவலானது TISL நடத்திய தகவல் சேகரிப்பு மற்றும் புகார் சரிபார்ப்பு போன்றவற்றிட்கும் பயன்படுத்தப்படலாம். நீங்கள் பதிவு செய்த தகவல்கள் உங்கள் அனுமதியுடன் மாத்திரம் பதிவு செய்த நபர் நம்ப தகுந்தவராயின் தேவையான அதிகாரிகளுக்கும் வேறு மூன்றாம் தரப்பினருக்கும் வழங்கப்படும்.",
    //"When you submit the location of the alleged incident of bribery or corruption, the website will use geo-tagging or location data to approximately identify the location where the incident happened. This location information is used for displaying the approximate location that the reported incident of bribery or corruption took place on the heat map provided on the website. This location information could also be used for fact finding, information gathering and complaint verification conducted by TISL. Information about the exact location as reported or submitted by you will only be disclosed to necessary authorities or other third parties only with your express consent and awareness, when the person who submitted the information is identifiable.",

    privacyPolicy_subTitle1P3: "1.3 வலைத்தள பயன்பாட்டுத் தகவல்", //"1.3. Website Use Information",
    privacyPolicy_subTitle1P3DescriptionP1: "வேறு வலைத்தளங்களைப் போலவே இவ்வலைத்தளமும் குக்கீகளைப் பயன்படுத்துகிறது. தகவல்களை சேகரிக்கும் பதிவு இடாப்பு நீங்கள் வலைத்தளத்தினை எவ்வாறு பயன்படுத்தினீர் என தகவல்களை சேகரித்து வைக்கலாம்.", //"Similar to other websites, this website utilizes a standard technology called 'cookies' and server logs and may collect information about how the website is used by you.",
    privacyPolicy_subTitle1P3DescriptionP2: "குக்கீ எனப்படுவது தனித்துவமான உரை ஆவணமாகும். நீங்கள் ஒரு வலைத்தளத்தை பயன்படுத்தும் போது அவ்வலைத்தளத்தின் கணிணி தண்ணியக்க இலத்திரனியல் அனுமதிகளை உங்கள் கணினியிடமிருந்து அனுமதி கோருகிறது. ஏனெனில் அது கோப்புகளை உங்கள் கணினியின் வன்தட்டில் சேகரித்து வைக்கிறது. உங்களது உலவியின் முன் தரப்புகள் அனுமதி வழங்கினால் ஒவ்வொரு வலைத்தளமும் அதனுடைய சொந்த குக்கீகளை உங்கள் உலவியிற்கு அனுப்புகின்றது.",
    //"A cookie is a very small text document which often includes an anonymous unique identifier. When you visit a website, that site's computer seeks certain electronic, automated permissions from your computer, to store this file in a part of your hard drive specifically designated for cookies. Each website can send its own cookie to your browser if your browser's preferences allow it.",
    privacyPolicy_subTitle1P3DescriptionP3: "குக்கீகளால் சேகரிக்கப்பட்ட தகவல், பயணம் செய்த நேரம் திகதி, பார்வையிட்ட பக்கங்கள், எமது வலைத்தளத்தில் செலவழித்த நேரம் மற்றும் எமது வலைத்தளத்திற்கு முன்பும் பின்பும் உலாவிய வலைத்தளங்களையும் பதிவு இடப்புகளில் சேகரிக்கின்றது.",
    //"Information gathered through cookies and server logs may include the date and time of visits, the pages viewed, the time spent on our website, and the websites visited just before and just after the website.",
    privacyPolicy_subTitle1P3DescriptionP4: "வலைத்தளத்தை பயன்படுத்தும் போது குக்கீகளை உங்களை வேறுபடுத்தி உங்கள் உலாவியிற்கு தனித்துவமான முன் தரப்புகளை வழங்குகிறது. வேறு தரப்புகளில் வலைத்தளம் குக்கீகளைப் பயன்படுத்தி வேறு தேவையற்ற விளம்பரங்களை தடுக்கிறது. குக்கீகள் பதிவு இடப்புகளுடன் சேர்ந்து தம் வலைத்தளத்திற்கு வருகை தந்த பயனர்களின் ஒன்றுபட்ட தொகையையும் நம் பயனர்கள் பாவிக்கும் பிரபலமான வலைத்தள பிரிவுகளையும் கணிக்க உதவுகிறது.",
    //"As you use the website, the website uses its cookies to differentiate you from other users so your preferences are unique to you. In some cases, the website also uses cookies to prevent you from seeing unnecessary advertisements or requiring you to log in more than is necessary for security. Cookies, in conjunction with our server log files, allow us to calculate the aggregate number of people visiting our website and parts of the website which are most popular with our users. This helps us gather feedback in order to constantly improve the website and our services. Cookies do not allow us to gather any personal information about you and we do not generally store any personal information that you provide to us, in your cookies.",
    privacyPolicy_subTitle1P3DescriptionP5: "இச்செயல் எமக்கு வலைத்தளத்தை மேம்படுத்த உதவுகிறது. குக்கீகளை உங்கள் தனிப்பட்ட தகவல்களை அறிய அனுமதி வழங்காது மேலும் உங்கள் குக்கீகளில் வழங்கிய தரவுகளை நங்கள் பதிந்து வைக்கவும் மாட்டோம். உலாவி அனுமதித்த குக்கீகளை மாத்திரமே வலைத்தளத்தை அணுக உதவுகிறது. உங்களுக்கு வேறு வலைத்தளங்களால் அனுப்பிய குக்கீகளையோ நம் வலைத்தளம் உங்களுக்கு அனுப்பிய குக்கீகளையோ எமது வலைத்தளத்தினால் அணுக முடியாது.",
    //"Please note that, to protect your privacy, your browser will only permit the website to access the cookies it has already sent to you, not the cookies sent to you by other websites. This means that our website can neither access cookies sent to you by other websites, nor can other websites access or recognize cookies sent by our website to your computer.",

    privacyPolicy_subTitle2: "2. மூன்றாம் தரப்பினருடன் உங்கள் தகவல்களை பகிர்ந்து கொள்ளல்",
    //"2. SHARING YOUR INFORMATION WITH THIRD PARTIES:",
    privacyPolicy_subTitle2DescriptionP1: "கீழே குறிப்பிடப்பட்டுள்ள தகவல்களில் அடங்காத உங்கள் விருப்புத் தெரிவிப்பு இல்லாமல் நாம் வேறு மூன்றாம் தரப்பினருடன் தகவல்களைப் பகிர்ந்துகொள்ள மாட்டோம்.",
    //"We will not share any information provided by you, without your express consent, with any third parties, except as detailed herein below.",
    privacyPolicy_subTitle2DescriptionP2: "ஒரு முறைப்பாடு வலைத்தளத்திற்கு அறிக்கையளிக்கப்பட்டால் TISL அது பற்றி பின் தொடர்ந்து குறித்த சம்பவம் தொடர்பாக நடவடிக்கைகளை எடுக்க முயற்சிக்கும். அவ்வாறான சந்தர்ப்பங்களில் நீங்கள் உங்கள் அடையாளத்தினை பகிர வேண்டிய நிலைமை ஏற்படலாம். நங்கள் உங்களின் உறுதியுடன் மாத்திரமே முன் தொடர்வோம். மேலும் ஒரு சம்பவம் தொடர்பாக முறையிடப்பட்டால் TISL நடுநிலையாக நின்று தரவுகளை வலைத்தளத்தில் உள்ளடக்கமாக பதிவு செய்யும்.",
    //"When a complaint is submitted to this website, TISL will follow-up on actions that can be taken in relation to the alleged incident reported. In such instances, you may be required to share your personal information. Please note that we will obtain your confirmation before we undertake any action on the request submitted by you, in this regard. When a story or report is submitted to the website, TISL will moderate and post them as content on the website.",
    privacyPolicy_subTitle2DescriptionP3: "மேலே குறிப்பிடப்பட்டவாறு குக்கீகளினால் சேகரிக்கப்பட்ட தகவல்களை நாம் மூன்றாம் தரப்புகளுடன் பகிர்ந்து கொள்ளமாட்டோம். நடைமுறை சட்டத்தில் அடங்கும் தருணத்தில் நீங்கள் வலைத்தளத்தைப் பயன்படுத்துவது தொடர்பான தகவல்களை நாங்கள் பகிர்ந்துகொள்ள வேண்டிய நிலை ஏற்படலாம். அ) சட்ட ஆவணங்களுடன் இணங்குதல் அல்லது உறுதி செய்தல். ஆ) எமது உரிமைகள், சொத்துக்கள், குறித்த வலைதளம் மற்றும் வலைதள பாவனையாளர்களை பாதுகாத்தல் அல்லது இ) மூன்றாம் நபர்கள் அல்லது எமது பாதுகாப்பு மற்றும் இவ் வலையமைப்பின் பயனர்களின் பாதுகாப்பினை இக்கட்டான சூழ்நிலையில் உறுதிப்படுத்தல்.",
    //"We do not share any information collected through cookies, as detailed above, with any third parties. We may be required to disclose information relating to your use of the website under applicable law or if we believe that such action is necessary to (a) conform to the law or comply with legal documents served upon us; (b) protect and defend our rights and property, the website, and/or the users of the website; or (c) act under circumstances to protect the safety of users of this website, our security or that of third parties.",

    privacyPolicy_subTitle3: "3. உங்கள் தரவுகளுக்கான பாதுகாப்பு", //"3. SECURITY FOR YOUR DATA:",
    privacyPolicy_subTitle3Description: "உங்கள் தரவுகளை அங்கீகரிக்கப்படாத பயனர்கள் கையாள்வதை தடுத்தல், தவறாக பயன்படுத்தல், தரவு துஷ்பிரயோகம் போன்றவற்றை தடுக்க தொழில்நுட்ப ரீதியாக சாத்தியமான அனைத்து முன்னெச்சரிக்கை நடவடிக்கைகளையும் பாதுகாப்பு நடவடிக்கைகளையும் நாம் மேற்கொள்வோம். வலைத்தளத்தை பாதுகாப்பானதாக மாற்ற, பிரச்சினைகளைக் கண்டறிய, தரவுகளை ஆராய, பரிசோதிக்க, சேவைகளை மேம்படுத்தவும் நாம் உங்கள் தகவல்களை பயன்படுத்தலாம். மேலும் உங்கள் தரவுகளை அறிய ஒப்பந்தப்படி இணங்கியவர்களுக்கு மாத்திரமே வரையறைகளுடன் அனுமதி வழங்குவோம்.",
    //"We will take all the appropriate precautions and the requisite security measures that are technically feasible to protect your information to prevent any unauthorized use, loss, misuse or alteration/abuse of your information. We may use the information we receive about you as part of our efforts to keep the website safe and secure, for internal operations including troubleshooting, data analysis, testing, research and service improvement. In any case, we restrict access of your personal information to select employees who need to know this information in order to operate, develop or improve our services, and who are contractually bound to protect such information.",

    privacyPolicy_subTitle4: "4. மூன்றாம் தர இணைப்பு", //"4. THIRD PARTY LINKS:",
    privacyPolicy_subTitle4DescriptionP1: "இவ்வலைத்தளம் TISL இனால் கட்டுப்படுத்தபடாத வேறு மூன்றாம் தர வலைத்தள இணைப்புகளுடன் தொடர்பு இருக்கலாம். இம்மூன்றாம் தர இணைப்புகள் உங்கள் வசதிற்கேற்ப உங்கள் விருப்புடன் கிடைக்கப்பெறும். Apesalli.lk மற்றும் TISL உடன் இணைக்கப்பட்டுள்ள மூன்றாம் தரப்பினரால் பயன்படுத்தப்படும் நடைமுறைகள் மற்றும் அதில் உள்ள உள்ளடக்கம் ஆகியவற்றுக்கு Apesalli.lk மற்றும் TISL பொறுப்பேற்காது என்பதை நினைவில் வைத்துக்கொள்ளுங்கள்.",
    //"This website may contain links to third party websites that are not controlled by TISL. These third party links are available to you as a convenience and you agree to use these links at your own risk. Please be aware that neither Apesalli.lk nor TISL is responsible for the practices employed by third party websites linked to Apesalli.lk or content contained therein.",
    privacyPolicy_subTitle4DescriptionP2: "பொதுவாக பிற வலைத்தளங்களுக்கான ஹைப்பர் இணைப்புக்கள் வலைத்தள பயனர்களுக்கு பயனுள்ள தலைப்புகளுக்கான சுட்டிகளாக மட்டுமே வழங்கப்படுகின்றன. எமது வலைத்தளத்திலிருந்து வேறு வளைத்தளமொன்றிற்கு இணைப்பை பயன்படுத்தி செல்லும் போது தனியுரிமைக் கொள்கை செல்லுபடியாட்டற்றதாக மாறும் என்பதை கருத்தில் கொள்ளவும். மேலதிக இணைப்பைக் கொண்ட வேறு எந்த வலைத்தளத்திலும் உங்கள் உலாவல் மற்றும் கணிப்பு அந்த மூன்றாம் தர இணைப்பின் சொந்த விதிமுறைகளுக்குட்பட்டது. அத்தகைய சூழ்நிலைகளில் நாங்கள் பொறுப்புக்கூற மாட்டோம்.",
    //"Often hyperlinks to other websites are provided solely as pointers to information on topics that may be useful to the users of the website. Please remember that when you use a link to go from our website to another web site, this Privacy Policy is no longer in effect. Your browsing and interaction on any other website, including websites which contain further links, is subject to that third party website's own rules and policies and we have no liability whatsoever, in such circumstances.",


    privacyPolicy_subTitle5: "5. இந்த தனியுரிமைக் கொள்கைக்கான மாற்றங்கள்",
    //"5. CHANGES TO THIS PRIVACY POLICY:",
    privacyPolicy_subTitle5Description1P1: "இந்த தனியுரிமைக் கொள்கை",
    //"This Privacy Policy is effective as of ",
    privacyPolicy_subTitle5Description1P2: "தினத்திலிருந்து செல்லுபடியாகும். எந்தவொரு மாற்றத்தினையும் நாம் உங்களுக்கு அறியத்தரும் வகையில் அத்தகவல்களையும், அத்தகவல்களை வெளிப்படுத்தும் சந்தர்ப்பங்களையும் வலைத்தளத்தில் பதிவு செய்வோம்.",
    //"In the event we change our Privacy Policy and procedures, we will post those changes on the website to keep you aware of what information we collect, how such information is used and under what circumstances we may disclose it.",
    privacyPolicy_subTitle5Description2: "எவ்வாறாயினும் அறியத்தரப்படாத தனியுரிமைக் கொள்கைகளை வலைத்தளத்தை பாவிப்பதன் மூலம் அறிந்து அதற்கு சம்மதம் தெரிவிக்கவும் கேட்டுக்கொள்ளப்படுகிறீர்கள்.",
    //"However, changes to the privacy policy may be made without prior notice, and by accessing this website you are deemed to be aware of the new/changed Privacy Policy; and to have consented to the same. You are requested to regularly visit this page to update yourself of the current and prevailing Privacy Policy.",
    privacyPolicy_subTitle5Description3: "குறிப்பு: பொருத்தமற்ற அல்லது முறைகேடான அல்லது அவதூறு கூறும் வகையில் எந்தவொரு அறிக்கையையும் சமர்ப்பிக்க வேண்டாம் அவ்வாறு சமர்ப்பிக்கும் பட்சத்தில் அது உங்கள் பொறுப்பிலாகும். ஒரு சட்ட அமுலாக்க நிறுவனம் குறித்த அறிக்கை அல்லது கதை சம்பந்தமான தகவல்களை கோரினால் உங்களது IP முகவரியை பகிர நாம் வேண்டப்படலாம். நீங்கள் வெற்றிகரமாக இட்ட விபரத்தை தொடர்ந்தால் நீங்கள் பொறுப்பேற்க வேண்டியேற்படும்.",
    //"Note: Please do not post fraudulent or defamatory reports or stories for which you may be liable. If a law enforcement agency challenges such report on a legal basis, we will be required to share your IP address. If successfully sued in relation to any content posted or submitted by you, you could be held liable.",


    //Share Story Form(Page) -----------------------------------------------

    //title
    //shareStory_title: "Share Your Experience and Views on Bribery and Corruption",

    shareStory_title: "இலஞ்சம் மற்றும் ஊழல் தொடர்பான சம்பவங்களை TISL க்கு முறையிடல்",
    //"Report Incidents of Bribery and Corruption to TISL",

    //form
    shareStory_publicAuthorityFieldTitle: "பொது அதிகாரம் சம்பந்தப்பட்டதா?", //"Public Authority Involved?",
    shareStory_publicAuthorityFieldAns1: "ஆம்", //"Yes",
    shareStory_publicAuthorityFieldAns2: "இல்லை", //"No",

    shareStory_authorityNamePlaceholder: "சம்பவத்துடன் தொடர்புடைய நபரின் பெயரும் பதவியும்",
    //"Name and Designation of The Person Involved",
    shareStory_authorityNameTooltip: "சம்பந்தப்பட்டவரின்  பெயர் மற்றும் பதவியை பதிவிடுக",
    //"Please Enter Name and the Designation of the Person Involved",

    shareStory_storyAuthorityPlaceholder: "அதிகாரசபையை தெரிவு செய்க", //"Select Authority",
    shareStory_storyAuthorityTooltip: "தயவு செய்து சம்பந்தப்பட்ட அதிகாரசபையை தெரிவு செய்க", //"Please Select Authority",

    shareStory_storyTitlePlaceholder: "தலைப்பு", //"Title",
    shareStory_storyTitleTooltip: "தயவுசெய்து கதையின் தலைப்பை பதிவிடுக",
    //"Please Enter Title of the Story",

    shareStory_dateFieldHelperText: "சம்பவம் நடந்த திகதி", //"Incident Date",
    shareStory_dateFieldTooltip: "தயவுசெய்து சம்பவ தினத்தை பதிவிடுக", //"Please Enter Date of Incident",

    shareStory_districtFieldPlaceholder: "மாவட்டத்தை தேர்வு செய்க", //"Select District",
    shareStory_districtFieldTooltip: "தயவுசெய்து மாவட்டத்தை தேர்வு செய்க", //"Please Select District",

    shareStory_storyFieldPlaceholder: "கதை", //"Your Story",
    shareStory_storyFieldTooltip: "தயவுசெய்து கதையை தேர்வு செய்க", //"Please Enter The Story",

    shareStory_storyFieldWordLimit: "சொல் எல்லை", //"Word Limit",

    //"Do You Want to Share Your Personal Information?",
    shareStory_shareInfoFieldTitle: "நீங்கள் உங்களது தனிப்பட்ட தகவல்களைப் பகிர விரும்புகிறீர்களா?",
    shareStory_shareInfoFieldAns1: "ஆம்", //"Yes",
    shareStory_shareInfoFieldAns2: "இல்லை", //"No",

    shareStory_nameField: "பெயர்", //"Name",
    shareStory_nameFieldTooltip: "தயவுசெய்து பெயரை பதிவிடுக", //"Please Enter Name",

    shareStory_phoneField: "தொலைபேசி இலக்கம்", //"Contact Number",
    shareStory_phoneFieldTooltip: "தயவுசெய்து தொலைபேசி இலக்கத்தை பதிவிடுக",
    //"Please Enter Contact Number",

    shareStory_emailField: "மின்னஞ்சல்", //"Email",
    shareStory_emailFieldTooltip: "தயவுசெய்து மின்னஞ்சல் முகவரியை பதிவிடுக", //"Please Enter Email",

    //form validation errors
    shareStory_requiredErrorMessageFieldDate: "திகதி அவசியம்", //"Date is Required !",
    shareStory_requiredErrorMessageFieldDistrict: "மாவட்டம் அவசியம்", //"District is Required !",
    shareStory_requiredErrorMessageFieldStory: "கதை அவசியம்", //"Story is Required !",
    shareStory_requiredErrorMessageFieldName: "பெயர் அவசியம்", //"Name is Required !",
    shareStory_requiredErrorMessageFieldEmail: "மின்னஞ்சல் முகவரி அவசியம்", //"Email is Required !",
    shareStory_requiredErrorMessageFieldContactNumber: "தொலைபேசி இலக்கம் அவசியம்",
    //"Contact Number is Required !",

    shareStory_ValidErrorMessageFieldEmail: "செல்லுபடியாகும் மின்னஞ்சல் முகவரியை பதிவிடுக",
    //"Enter Valid Email Address !",
    shareStory_contactNumberErrorMessageField: "தயவுசெய்து செல்லுபடியாகும் தொலைபேசி இலக்கத்தை பதிவிடுக.",
    //"Please Enter Valid Contact Number(Eg:0772345678)",

    //dialog boxes
    shareStory_storyFieldDialogMessage: "தயவுசெய்து இலஞ்சம் கேட்டமைக்கான காரணம், சம்பந்தப்பட்ட அரச அதிகாரியின் பெயர் மற்றும் பதவி, சம்பவம் நடந்த நேரம் போன்ற தகவல்கள் உட்பட மேலதிக விபரங்களை பதிவிடவும்.",
    //"Please Enter Further Details Including The Reason For Asking For The Bribe, Name and Designation of The Public Official Involved, Time of The Incident, etc.",
    shareStory_storyFieldDialogButton: "சரி", //"Ok",

    shareStory_noteDialogMessageTitle: "குறிப்பு", //"Note",
    shareStory_noteDialogMessage: "உங்களால் முடியுமான தனிப்பட்ட தரவுகள் வழங்குவதை நாம்  ஊக்குவிக்கிறோம், அதனடிப்படையில் முறைப்பாடுகளை சரிபார்ப்பது எமக்கு இலகுவானது.",
    //"We encourage you to provide as much personal information as possible, so we have a better chance of verifying the complaint/story.",

    shareStory_afterShareDialogMessageTitle: "ஊழலுக்கு எதிராக செயற்பட்டமைக்கு நன்றி !",
    //"Thank You for Standing Against Corruption !",
    shareStory_afterShareDialogMessageP1: "உங்களுடைய குறிப்பு இலக்கம்", //"Your Reference Number is",
    shareStory_afterShareDialogMessageP2: "உங்களது அறிக்கை வெற்றிகரமாக சமர்ப்பிக்கப்பட்டுள்ளது !",
    //"Your Report Submitted Successfully!.",
    shareStory_afterShareDialogMessageP3: "நீங்கள் இன்னும் பல ஆதாரங்கள் அல்லது ஆவணங்களை சமர்ப்பிக்க விரும்பினால் உங்களது குறியீட்டு இலக்கத்தை ஆவணங்களின் மேல் இடப்பக்க மூலையில் குறிப்பிட்டு அவற்றை தயவுசெய்து “இல.366, நாவலை வீதி,  நாவலை, ராஜகிரிய“ என்ற முகவரிக்கு தபால் மூலம் அனுப்பவும் அல்லது ஆவணங்களை 0112865777 என்ற நம்பருக்கு தொலைநகல் மூலமாக அனுப்பவும்",
    //'*If you wish to submit more supporting documents or evidence, please post them to "Program Officer, Transparency Intermational Sri Lanka, 5/1, Elibank Road, Colombo 05" mentioning the reference number on the top left corner of the document. Or Fax the documents anonymously to 0112865777.',
    shareStory_afterShareDialogButton: "சரி", //"Ok",

    //info alert
    shareStory_infoText: "உரிய மதிப்பாய்வைத் தொடர்ந்து கதைகள் பகிரப்படும்",
    //"Stories will be shared following review by administrator ",

    //button
    shareStory_shareButton: "பகிருக", //"Share",

    //25 districts
    lng_Districts: [
        { value: "National level", lat: 6.9271, lng: 79.8612, label: "தேசிய மட்டம்" },
        { value: "Ampara", lat: 7.3018, lng: 81.6747, label: "அம்பாறை" },
        { value: "Anuradhapura", lat: 8.3114, lng: 80.4037, label: "அநுராதபுரம்" },
        { value: "Badulla", lat: 6.9934, lng: 81.0550, label: "பதுளை" },
        { value: "Batticaloa", lat: 7.7310, lng: 81.6747, label: "மட்டக்களப்பு" },
        { value: "Colombo", lat: 6.9271, lng: 79.8612, label: "கொழும்பு" },
        { value: "Galle", lat: 6.0535, lng: 80.2210, label: "காலி" },
        { value: "Gampaha", lat: 7.0840, lng: 80.0098, label: "கம்பஹா" },
        { value: "Hambantota", lat: 6.1429, lng: 81.1212, label: "ஹம்பாந்தோட்டை" },
        { value: "Jaffna", lat: 9.6615, lng: 80.0255, label: "யாழ்ப்பாணம்" },
        { value: "Kalutara", lat: 6.5854, lng: 79.9607, label: "களுத்துறை" },
        { value: "Kandy", lat: 7.2906, lng: 80.6337, label: "கண்டி" },
        { value: "Kegalle", lat: 7.2513, lng: 80.3464, label: "கேகாலை" },
        { value: "Kilinochchi", lat: 9.3803, lng: 80.3770, label: "கிளிநொச்சி" },
        { value: "Kurunegala", lat: 7.4818, lng: 80.3609, label: "குருநாகல்" },
        { value: "Mannar", lat: 8.9810, lng: 79.9044, label: "மன்னார்" },
        { value: "Matale", lat: 7.4675, lng: 80.6234, label: "மாத்தளை" },
        { value: "Matara", lat: 5.9549, lng: 80.5550, label: "மாத்தறை" },
        { value: "Monaragala", lat: 6.8728, lng: 81.3507, label: "மொனராகலை" },
        { value: "Mullaitivu", lat: 9.2671, lng: 80.8142, label: "முல்லைத்தீவு" },
        { value: "Nuwara Eliya", lat: 6.9497, lng: 80.7891, label: "நுவரேலியா" },
        { value: "Polonnaruwa", lat: 7.9403, lng: 81.0188, label: "பொலன்னறுவை" },
        { value: "Puttalam", lat: 8.0408, lng: 79.8394, label: "புத்தளம்" },
        { value: "Ratnapura", lat: 6.7056, lng: 80.3847, label: "இரத்தினபுரி" },
        { value: "Trincomalee", lat: 8.5874, lng: 81.2152, label: "திருகோணமலை" },
        { value: "Vavuniya", lat: 8.7542, lng: 80.4982, label: "வவுனியா" },
    ],

    //public authorities
    lng_publicAuthorities: [
        {
            label: "அரச நிறுவனங்கள்",
            value: "Public Sector Organizations",
        },
        {
            label: "தனியார் நிறுவனங்கள்",
            value: "Private Sector Organizations",
        },
        {
            label: "அரச சார்பற்ற நிறுவனங்கள்",
            value: "Non-government Organizations",
        },
    ],

    //incident types
    lng_incidentTypes: [
        {
            key: 1,
            label: "நடந்து முடிந்த சம்பவம்",
            value: "Has Happened",
        },
        {
            key: 2,
            label: "தற்பொழுது நடைபெறுகின்ற சம்பவம்",
            value: "Is Happening",
        },
        {
            key: 3,
            label: "எதிர்காலத்தில் நடக்கவிருக்கின்ற சம்பவம்",
            value: "Will Happen in the future",
        },
    ],

    //Report Corruption Form(Page) -----------------------------------------------

    //title
    //corruptionReport_title: "Report Incidents of Bribery and Corruption to TISL",

    corruptionReport_title: "இலஞ்சம் மற்றும் ஊழல் குறித்து உங்களது அனுபவத்தையும் கருத்தினையும் பகிர்ந்து கொள்ளுங்கள்",
    //"Share Your Experience and Views on Bribery and Corruption",

    //stepper Steps
    corruptionReport_stepperSteps:
        [
            "நம்பகதன்மை", //"Confidentiality",
            "வகைப்படுத்தலுக்கேற்ற தகவல்கள்", //"Select Category",
            "பொதுவான தகவல்கள்", //"General Information",
            "தகவல் வகை", //"Category Information",
        ],

    //Step 1 - form 1
    corruptionReport_ShareDetailsCheckbox1: "எனது தனிப்பட்ட தகவல்களைப் பகிர விரும்புகிறேன்",
    //"I want to share my details.",
    corruptionReport_ShareDetailsCheckbox2: "நான் பெயர் அறியப்படாதவராக இருக்க விரும்புகிறேன்",
    //"I want to stay anonymous.",

    corruptionReport_step1NameFieldTooltip: "தயவுசெய்து பெயரை பதிவிடுக", //"Please Enter Your Name",
    corruptionReport_step1NameFieldPlaceholder: "பெயர் ", //"Name",
    corruptionReport_step1NameFieldErrorMessage: "பெயர் அவசியம்", //"Name is required!",
    corruptionReport_step1NameFieldIsString: "சரியான பெயரை உள்ளிடவும்",

    corruptionReport_step1AgeFieldTooltip: "தயவுசெய்து உங்களது வயதை பதிவிடுக", //"Please Enter Your Age",
    corruptionReport_step1AgeFieldPlaceholder: "வயது ", //"Select Age",
    corruptionReport_step1AgeFieldErrorMessage: "வயது அவசியம்", //"Age is required!",

    corruptionReport_step1AddressFieldTooltip: "தயவுசெய்து உங்களது முகவரியை பதிவிடுக",
    //"Please Enter Your Address",
    corruptionReport_step1AddressFieldPlaceholder: "முகவரி", //"Address",
    corruptionReport_step1AddressFieldErrorMessage: "முகவரி அவசியம்", //"Address is required!",

    corruptionReport_step1ContactNumberFieldTooltip: "தயவுசெய்து தொலைபேசி இலக்கத்தை பதிவிடுக",
    //"Please Enter Your Contact Number",
    corruptionReport_step1ContactNumberFieldPlaceholder: "தொடர்பு இலக்கம்", //"Contact Number",
    corruptionReport_step1ContactNumberFieldErrorMessage1: "தொலைபேசி இலக்கம்", //"Contact Number is required!",
    corruptionReport_step1ContactNumberFieldErrorMessage2: "தயவுசெய்து செல்லுபடியாகும் தொலைபேசி இலக்கத்தை பதிவிடுக",
    //"Please enter valid Phone Number(Eg:0772345678)",

    corruptionReport_step1EmailFieldTooltip: "தயவுசெய்து மின்னஞ்சல் முகவரியை பதிவிடுக",
    //"Please Enter Your Email",
    corruptionReport_step1EmailFieldPlaceholder: "மின்னஞ்சல் முகவரி", //"Email",
    corruptionReport_step1EmailFieldErrorMessage1: "மின்னஞ்சல் முகவரி அவசியம்", //"Email is required!",
    corruptionReport_step1EmailFieldErrorMessage1: "செல்லுபடியாகும் மின்னஞ்சல் முகவரியை பதிவிடுக",
    //"Please Enter Valid Email",

    corruptionReport_step1GenderFieldTooltip: "பால்நிலையை தேர்வு செய்க", //"Select Gender",

    //genders
    lng_genders: [
        {
            key: "gender_type2",
            label: "ஆண்",
            value: "Male",
        },
        {
            key: "gender_type3",
            label: "பெண்",
            value: "Female",
        },
        {
            key: "gender_type4",
            label: "வேறு",
            value: "Other",
        },
        {
            key: "gender_type5",
            label: "சொல்லாமல் இருப்பதை விரும்புகிறேன்",
            value: "Prefer not to say",
        },
    ],

    //anonymous form
    corruptionReport_step1AnonymousFormGenderFieldTooltip: "தயவுசெய்து உங்களது பால்நிலையை தேர்வு செய்க",
    //"Please Select Your Gender",
    corruptionReport_step1AnonymousFormGenderFieldPlaceholder: "பால்நிலையை தேர்வு செய்க", //"Select Gender",
    corruptionReport_step1AnonymousFormGenderFieldError: "பால்நிலை அவசியம்", //"Gender is required!",

    //dialogBox
    corruptionReport_nextDialogBoxStep1Title: "செயன்முறையை தொடர்வதற்கு தயவுசெய்து கீழ் உள்ளவற்றில் ஒன்றை தேர்வு செய்க",
    //"To continue with the processing please select one of the below,",

    corruptionReport_nextDialogBoxSelection: [
        {
            value: "எமது ஊழியர் ஒருவர் உங்களை தொடர்பு கொள்ளுமாறு வேண்டுதல்",
            //"Answer the questionnare",
        },
        {
            value: "கேள்விகளுக்கு பதில் அளித்தல்",
            //"Ask our staff to contact you",
        }
    ],

    corruptionReport_nextDialogBoxStep1AskToContactTitleP1: "ஊழலுக்கு எதிராக செயற்பட்டமைக்கு மிக்க நன்றி!",
    //"Thank You for Standing Against Corruption !",
    corruptionReport_nextDialogBoxStep1AskToContactTitleP2: "உங்கள் குறியீட்டு இலக்கம்",
    //"Your Reference Number is ",
    corruptionReport_nextDialogBoxStep1AskToContactDescriptionP1: "உங்கள் அறிக்கை வெற்றிகரமாக சமர்ப்பிக்கப்பட்டுள்ளது!",
    //"Your Report Submitted Successfully!.",
    corruptionReport_nextDialogBoxStep1AskToContactDescriptionP2: "நீங்கள் இன்னும் பல ஆதாரங்கள் அல்லது ஆவணங்களை சமர்ப்பிக்க விரும்பினால் உங்களது குறியீட்டு இலக்கத்தை ஆவணங்களின் மேல் இடப்பக்க மூலையில் குறிப்பிட்டு அவற்றை தயவுசெய்து “இல.366, நாவலை வீதி,  நாவலை, ராஜகிரிய“ என்ற முகவரிக்கு தபால் மூலம் அனுப்பி வைக்கவும்.",
    //'If you wish to submit more supporting documents or evidence, please post them to "PPP Program Officer, Transparency International Sri Lanka, 5/1, Elibank Road, Colombo 05." mentioning the reference number on the top left corner of the document.',

    corruptionReport_anonymousSwitchDialogBoxTitle: "குறிப்பு",
    //"Note",
    corruptionReport_anonymousSwitchDialogBoxDescription: "உங்களால் முடியுமான தனிப்பட்ட தரவுகள் வழங்குவதை நாம்  ஊக்குவிக்கிறோம் அதனடிப்படையில் முறைப்பாடுகளை சரிபார்ப்பது எமக்கு இலகுவானது.",
    //"We encourage you to provide as much personal information as possible, so we have a better chance of verifying the complaint/story.",


    //button
    corruptionReport_step1NextButton: "அடுத்து", //"Next",

    corruptionReport_nextDialogBoxStep1Button1: "அடுத்து", //"Next",
    corruptionReport_nextDialogBoxStep1Button2: "ரத்து செய்", //"Cancel",

    corruptionReport_nextDialogBoxStep1AfterAskToContactButton: "சரி", //"Ok",

    corruptionReport_step1AnonymousFormNextButton: "அடுத்து", //"Next",

    //Step 2 - selection

    //categories
    lng_corruption_types: [

        {
            key: 1,
            label: "இலஞ்சம்", //"Bribery",
            value: "Bribery",
            desc: "வழங்குதல், நம்பிக்கையளித்தல், கொடுத்தல் மற்றும் ஏற்றுக்கொள்ளல் அல்லது நன்மை /பயன் கருதி எதிர்பார்த்தல் அல்லது முறையற்ற, சட்ட விரோதமான, தூண்டுதல் பரிசாக, கடனாக, கட்டணமாக, கொடுப்பனவாக கொடுத்தல்.[வரிகள், சேவைகள், கொடுப்பனவுகள்]",
            //"The offering, promising, giving, accepting or soliciting of an advantage as an inducement for an action which is illegal, unethical or a breach of trust. Inducements can take the form of gifts, loans, fees, rewards or other advantages (taxes, services, donations, etc.) (TI plain language guide)",
        },
        {
            key: 2,
            label: "பாலியல் ரீதியான சலுகைகள்", //"Sexual Favours",
            value: "Sexual Favours",
            desc: "ஒரு தனி நபர் பொது சட்டம் மற்றும் சமாதான அல்லது பொலிஸ் சேவைகளுக்காக செல்லுமிடத்து அவர் பாலியல் ரீதியான சலுகைகளுக்கு நிர்ப்பந்திக்கப்படல்.",
            //"when an individual who goes to a public, judicial, peace or police officer for a public service is required to perform a sexual favour in return for the service that they are entitled to by the law (Article by Shyamala Gomez)",
        },
        {
            key: 3,
            label: "பொது நிதியையும் சொத்துக்களையும் தவறாக பயன்படுத்தல்", //"Misuse of Public Funds or Property",
            value: "Misuse of Public Funds or Property",
            desc: "அதிகாரமிருக்கும் உத்தியோகத்தர் தனது சொந்த தேவைகளுக்காக பொது நிதியையும் சொத்துக்களையும் பயன்படுத்தல்.",
            //"When a person holding office in an institution, organisation or company dishonestly and illegally appropriates, uses or traffics the funds and goods they have been entrusted with for personal enrichment or other activities. (TI plain language guide, slightly amended the Embezzlement definition to match this)",

        },
        {
            key: 4,
            label: "பொதுப்பதவிகளை தவறாக பயன்படுத்தல்", //"Misuse of Public Position",
            value: "Misuse of Public Position",
            desc: "ஒரு நபர் தனது அலுவலகத்தை முறையற்ற விதத்தில் தனக்கு அல்லது மற்றொருவரின் நன்மைக்காக பயன்படுத்துதல்.",
            // desc: "ஒரு நிறுவனம், அமைப்பு அல்லது நிறுவனத்தில் பதவியில் இருப்பவர் நேர்மையற்றதாகவும் சட்டவிரோதமாகவும் தனிப்பட்ட செறிவூட்டல் அல்லது பிற நடவடிக்கைகளுக்காக அவர்கள் ஒப்படைத்துள்ள நிதி மற்றும் பொருட்களை பயன்படுத்துதல்.", 
            //"A person who uses his office to improperly benefit oneself or another person. (Ethics and Anti-Corruption Commission Kenya definition)"
        },
        {
            key: 5,
            label: "விருப்பச்சார்பான முரண்பாடு", //"Conflict of Interest",
            value: "Conflict of Interest",
            desc: "ஒரு தனிநபர் அல்லது அவர் பணியாற்றும் நிறுவனம், ஓர் அரசாங்கம், வணிகம், ஊடகம் அல்லது சிவில் சமூக அமைப்பு எதுவாக இருப்பினும் அவர்களின் பதவி, கடமை மற்றும் கோரிக்கைகளுக்கு இடையிலான சொந்த விருப்பத்தை எதிர்காள்ளும் தன்மை.",
            //"Situation where an individual or the entity for which they work, whether a government, business, media outlet or civil society organization, is confronted with choosing between the duties and demands of their position and their own private interests ",
        },
        {
            key: 6,
            label: "பொது கொள்முதல் முறைகேடுகள்", //"Public Procurement Irregularities",
            value: "Public Procurement Irregularities",
            desc: "தனிநபர் அல்லது நிறுவனம் ஒன்று பொருட்கள் அல்லது சேவைகளை கொள்வனவு செய்யும் போது ஏற்படக்கூடிய முறைகேடுகள்",
            //"Any irregularities in multi-step process of established procedures to acquire goods and services by any individual, company or organization — from the initial needs assessment to the contract’s award and service delivery (Ethics and Anti-Corruption Commission Kenya definition)"
        },
        {
            key: 7,
            label: "ஏனையவை", //"Other",
            value: "Other",
            desc: "ஏனையவை", //"other",
        },

    ],

    //button
    corruptionReport_step2Button: "பின்", //"Back",

    //Step 3 - Form

    //form
    corruptionReport_step3PublicAuthorityFieldTitle: "சம்பந்தப்பட்ட பொது அதிகார துறை",
    //"Public Authority Involved",
    corruptionReport_step3PublicAuthorityFieldAns1: "ஆம்", //"Yes",
    corruptionReport_step3PublicAuthorityFieldAns2: "இல்லை", //"No",

    corruptionReport_step3PublicAuthorityNameFieldTooltip: "தயவுசெய்து சம்பந்தப்பட்ட அதிகாரத்தை தெரிவு செய்க",
    //"Please Select Authority Involved",
    corruptionReport_step3PublicAuthorityNameFieldPlaceHolder: "அதிகாரசபையை தெரிவு செய்க", //"Select Authority",
    corruptionReport_step3PublicAuthorityNameFieldRequired: "தயவு செய்து சம்பந்தப்பட்ட அதிகாரசபையை தெரிவு செய்க",
    //"Authority field is required!",

    corruptionReport_step3PublicAuthorityDesignationFieldTooltip: "சம்பவத்துடன் தொடர்புடைய நபரின் பெயரும் பதவியும்",
    //"Please Enter Name and Designation of the Person Involved",
    corruptionReport_step3PublicAuthorityDesignationFieldPlaceHolder: "சம்பந்தப்பட்ட நபரின் பெயரும் பதவியும்",
    //"Name and Designation of The Person Involved",
    corruptionReport_step3PublicAuthorityDesignationFieldRequired: "பெயர் மற்றும் பதவி நிரல்கள் அவசியம்",
    //"Name and Designation field is required!",

    corruptionReport_step3IncidentStatusFieldTooltip: "சம்பவத்தின் நிலைமையை தெரிவு செய்க",
    //"Please Select Incident Status",
    corruptionReport_step3IncidentStatusFieldPlaceHolder: "தயவு செய்து சம்பவத்தின் நிலைமையை தெரிவு செய்க",
    //"Select Incident Status",
    corruptionReport_step3IncidentStatusFieldRequired: "சம்பவத்தின் தன்மையினை நிரல் அவசியம்",
    //"Incident Status field is required!",

    corruptionReport_step3DistrictTooltip: "தயவுசெய்து மாவட்டத்தை தெரிவு செய்க", //"Please Select District",
    corruptionReport_step3DistrictPlaceHolder: "மாவட்டத்தை தெரிவு செய்க", //"Select District",
    corruptionReport_step3DistrictRequired: "மாவட்ட நிரல் அவசியம்", //"District field is required!",

    corruptionReport_step3DivisionalSecretariatsTooltip: "தயவுசெய்து பிரதேச செயலகத்தை தெரிவு செய்க",
    //"Please Select Divisional Secretariat",
    corruptionReport_step3DivisionalSecretariatsPlaceHolder: "பிரதேச செயலக பிரிவு",
    //"Select Divisional Secretariat",
    corruptionReport_step3DivisionalSecretariatsRequired: "பிரதேச செயலக நிரல் அவசியம்",
    //"Divisional Secretariat field is required!",

    corruptionReport_step3DateTooltip: "தயவுசெய்து  சம்பவ தினத்தை தெரிவு செய்க",
    //"Please Select Date of Incident",
    corruptionReport_step3DatePlaceHolder: "சமர்ப்பிக்கப்பட்ட சம்பவம் நடந்த திகதி", //"Select Date",
    corruptionReport_step3DateRequired: "திகதி நிரல் அவசியம்",
    //"Date field is required!",

    corruptionReport_step3TimeTooltip: "தயவுசெய்து சம்பவ நேரத்தை தெரிவு செய்க",
    //"Please Select Time of Incident",
    corruptionReport_step3TimePlaceHolder: "சமர்ப்பிக்கப்பட்ட சம்பவம் நடந்த நேரம்",//"Select Time",
    corruptionReport_step3TimeRequired: "நேர நிரல் அவசியம்", //"Time field is required!",

    corruptionReport_step3MapTitle: "சுயமாக தேர்ந்தெடுக்கப்பட்ட இடம் தவறாக இருந்தால் அல்லது சம்பவத்தின் சரியான இடம் உங்களுக்குத் தெரிந்தால், தயவுசெய்து  கீழே உள்ள வரைபடத்தில் அதைத் தேர்ந்தெடுக்கவும்",
    //"If the automatically selected location is incorrect or if you know the exact location of the incident, please select it on the map below.",

    //buttons
    corruptionReport_step3BackButton: "பின்", //"Back",
    corruptionReport_step3NextButton: "அடுத்து", //"Next",

    //step 4 - form

    //bribery from & sexual favor form common

    corruptionReport_step4_Bribery_field1Title: "முறைப்பாட்டுடன் தொடர்புடைய நபர்",
    //"Is the person you are reporting a*:",

    //person types
    lng_ReportingPersonTypes: [
        {
            key: 1,
            label: 'முகவர்',
            value: 'Agent',
        },
        {
            key: 2,
            label: 'கொடுப்பவர்',
            value: 'Giver',
        },
        {
            key: 3,
            label: 'பெறுபவர்',
            value: 'Recipient',
        },
        {
            key: 4,
            label: 'தெரியாதவர்',
            value: 'Unknown',
        },
    ],

    //bribe typeS
    lng_Corruption_Bribe_Types: [

        { key: 1, label: "நியமனம்", value: "Appointment" },
        { key: 2, label: "பணம்", value: "Cash" },
        { key: 3, label: "சொத்து மற்றும் சொத்துக்களுக்கான விருப்பு", value: "Property or interest in property" },
        { key: 4, label: "தரகு", value: "Commission" },
        { key: 5, label: "மதிப்புடைய பாதுகாப்பு", value: "Valuable Security" },
        { key: 6, label: "எந்தவொரு நடவடிக்கையும் மேற்கொள்ளாமை", value: "Failure to take action" },
        { key: 7, label: "உதவி ", value: "Favor" },
        { key: 8, label: "கட்டணம்", value: "Fee" },
        { key: 9, label: "அன்பளிப்பு", value: "Gift" },
        { key: 10, label: "கடன்", value: "Loan" },
        { key: 11, label: "வாக்குறுதி", value: "Promise" },
        { key: 12, label: "வெகுமதி", value: "Reward" },
        { key: 13, label: "சேவை", value: "Service" },

    ],

    //bribe type form field
    corruptionReport_step4_Bribery_field2Title: "தயவுசெய்து இலஞ்ச வகையை தெரிவு செய்க",
    //"Please Select Bribe Type",
    corruptionReport_step4_Bribery_field2Placeholder: "இலஞ்சத்தின் வகை", //"In what form was the bribe",
    corruptionReport_step4_Bribery_field2Error: "இலஞ்ச வகை அவசியம்",
    //"Bribe Type is required",

    //monetary value form field
    corruptionReport_step4_Bribery_field3Title: "தயவுசெய்து தொகையை பதிவிடுக",
    //"Please Enter the amount",
    corruptionReport_step4_Bribery_field3Placeholder: "பண மதிப்பு", //"Monetary Value",

    //misused properties
    corruptionReport_step4_MisuseProperty_fieldTitle: "தயவுசெய்து சொத்தின் வகையை தெரிவு செய்க",
    //"Please Select Type of The Property",
    corruptionReport_step4_MisuseProperty_fieldPlaceholder: "சொத்தின் வகை",
    //"Select Type of The Property",
    corruptionReport_step4_MisuseProperty_fieldError: "சொத்தின் வகை அவசியம்",
    //"Type of Property is required",

    lng_misused_PropertyTypes: [
        { key: 1, label: "பணம்", value: "Money" },
        { key: 2, label: "நிலம்", value: "Land" },
        { key: 3, label: "கட்டிடங்கள்", value: "Buildings" },
        { key: 4, label: "வாகனம்", value: "Vehicle" },
        { key: 5, label: "உபகரணங்கள்", value: "Equipment" },
        { key: 6, label: "அரச உத்தியோகத்தர்கள்/ மனித வளங்கள்", value: "Public officials/Human resources" },
        { key: 7, label: "ஏனையவை", value: "Other" },
    ],

    //misused position
    corruptionReport_step4_MisusePosition_fieldTitle: "குற்றஞ்சாட்டப்பட்ட நபரால் பெறப்பட்ட  அல்லது வழங்கப்பட்ட சலுகைகள் என்ன?",
    //"What benefit has the culprit obtained or given out?",
    corruptionReport_step4_MisusePosition_fieldPlaceholder: "குற்றஞ்சாட்டப்பட்ட நபரால் பெறப்பட்ட சலுகைகள் என்ன?",
    //"What benefit has the culprit obtained?",
    corruptionReport_step4_MisusePosition_fieldError: "சாட்சி/இணைப்புக்கள்",
    //"Benefit is required",

    //conflict of interest types
    lng_conflictOFInterest_AnswerTypes: [
        {
            key: "type1",
            label: "ஆம்",
            value: "Yes",
        },
        {
            key: "type2",
            label: "இல்லை",
            value: "No",
        },
        {
            key: "type3",
            label: "தெரியாது",
            value: "Unknown",
        }
    ],

    //conflict of interest form fields

    corruptionReport_step4_ConflictOFInterest_field1Title: "குறித்த நபருக்கு தனிப்பட்ட தொடர்புகள்/ விருப்பங்கள் ஏதேனும் உள்ளதா?",
    //Does the person have a private interest?",
    corruptionReport_step4_ConflictOFInterest_field2Title: "குறித்த நபர் தனது தனிப்பட்ட விருப்பத்தினை வெளிப்படுத்தினாரா?",
    //"Did the person disclose his or her interest?",
    corruptionReport_step4_ConflictOFInterest_field3Title: "அவன் அல்லது அவளின் தனிப்பட்ட விருப்பத்தின் அடிப்படையில் தீர்மானம் எடுக்கும் செயற்பாட்டில் பங்கேற்றாரா?",
    //"Did he or she participate in the making of a decision that involved his or her private interest?",
    corruptionReport_step4_ConflictOFInterest_field4Title: "குறித்த தீர்மானம் எடுக்கும் செயற்பாட்டில் ஈடுபட குறித்த நபருக்கு அதிகாரம் உள்ளதா?",
    //"Was the person authorized to participate in the process of making that decision?",

    corruptionReport_step4_ConflictOFInterest_field5Title: "விருப்பச்சார்ப்பு தன்மை",
    //"Please Select Nature of Interest",
    corruptionReport_step4_ConflictOFInterest_field5PlaceHolder: "விருப்பச்சார்ப்பு தன்மையினை தெரிவு செய்க",
    //"Select Nature of Interest",

    lng_conflictOFInterest_NatureOfInterestTypes: [
        { key: 1, label: "சுய கையாளுதல்", value: "Self-Dealing" },
        { key: 2, label: "வேலைவாய்ப்புக்கு வெளியே", value: "Outside Employment" },
        { key: 3, label: "குடும்பத்துடன் தொடர்புடைய விருப்பங்கள்", value: "Family Interests" },
        { key: 4, label: "பரிசுகள்", value: "Gifts" },
        { key: 5, label: "தெரியாது", value: "Unknown" },
    ],

    //procurement form fields
    corruptionReport_step4_Procurement_fieldTitle: "நீங்கள் எந்த வகையான பொது கொள்முதல் முறைகேட்டைப் முறையிடுகிறீர்கள்?",
    //"What type of public procurement irregularity?",
    corruptionReport_step4_Procurement_fieldPlaceholder: "பொது கொள்முதல் தொடர்பான முறைகேட்டின் வகை",
    //"Type of the public procurement irregularity",

    lng_procurementTypes: [
        { key: 1, label: "திறந்த டெண்டர் அழைப்பின் குறைபாடு", value: "Absence of open tendering" },
        { key: 2, label: "மோசடியில் பங்கேற்றல்", value: "Collusion" },
        { key: 3, label: "விருப்பச்சார்பான முரண்பாடு", value: "Conflict of Interest" },
        { key: 4, label: "தகுதி இல்லாமை", value: "Lack of qualification" },
        { key: 5, label: "தெரியாது", value: "Unknown" },
    ],

    //other details form filed
    corruptionReport_step4_Other_fieldTitle: "வேறு ஏதேனும் விபரங்கள்",
    //"More Details",
    corruptionReport_step4_Other_fieldPlaceholder: "மேலதிக விபரங்கள்", // "Any Other Details",
    corruptionReport_step4_Other_fieldError: "வேறு ஏதேனும் விவரங்கள்",
    //"Description is required",

    //button
    corruptionReport_step4BackButton: "பின்", //"Back",
    corruptionReport_step4FinishButton: "முடிவு", //"Finish",

    //file upload
    corruptionReport_step4UploadButton: "புகைப்பட ஆதாரங்களை பதிவேற்றல்", //"Upload Images",
    corruptionReport_step4UploadButtonVideo: "வீடியோ ஆதாரங்களை பதிவேற்றல்", //"Upload Videos",
    corruptionReport_step4TrashIconTooltip: "அகற்றவும்", //"Remove",
    corruptionReport_step4UploadButtonText: "தெரிவு செய்யப்பட்ட கோப்புக்கள்:", //"Files Chosen:",

    //instructions
    corruptionReport_step4InstructionsTitle: "சமர்ப்பிக்க முன் தயவுசெய்து வாசிக்கவும்",
    //"Please Read Before Submit",
    corruptionReport_step4InstructionsDescription: "உங்களது அநாமதேயத்தை பாதிக்கக்கூடிய மறைக்கப்பட்ட தனிப்பட்ட தகவல்களை இக்கோப்புக்கள் கொண்டிருக்கலாம். நீங்கள் அடையாளம் தெரியாதவராக இருக்க விரும்பினால் தயவுசெய்து கோப்புகளை பதிவேற்றம் முன் அவ்வாறான தகவல்களை அகற்றவும். உங்களுக்கு தகவல்களை அகற்ற இயலாமல் போனால் தயவுசெய்து அச்சு பிரதி எடுக்கப்பட்ட ஆவணத்தை அடையாளத்தை வெளிப்படுத்தாமல் “இல.366, நாவலை வீதி,  நாவலை, ராஜகிரிய“ என்ற முகவரிக்கு தபால் மூலம் அனுப்பி வைக்கவும். தயவுசெய்து அறிக்கை இடும் செயன்முறையின் இறுதியில் வழங்கப்படும் குறியீட்டு இலக்கத்தை குறிக்கவும்",
    //'Files may contain hidden personal information that could jeopardize your anonymity. If you wish to remain anonymous, please remove all such information before uploading a file. If you are unable to remove such information, please send a printed copy of the document anonymously to "PPP Program Officer, Transparency International Sri Lanka, 5/1, Elibank Road, Colombo 05". Please mention the reference number that is provided at the end of the reporting process.',

    //Dialog box step 4
    corruptionReport_step4DialogBoxTitleP1: "ஊழலுக்கு எதிராக செயற்பட்டமைக்கு நன்றி!",
    //"Thank You for Standing Against Corruption !",
    corruptionReport_step4DialogBoxTitleP2: "உங்கள் குறியீட்டு இலக்கம்", //"Your Reference Number is ",

    corruptionReport_step4DialogBoxDescriptionP1: "உங்கள் அறிக்கை வெற்றிகரமாக சமர்ப்பிக்கப்பட்டுள்ளது!",
    //"Your Report Submitted Successfully!.",
    corruptionReport_step4DialogBoxDescriptionP2: "நீங்கள் இன்னும் பல ஆதாரங்கள் அல்லது ஆவணங்களை சமர்ப்பிக்க விரும்பினால் உங்களது குறியீட்டு இலக்கத்தை ஆவணங்களின் மேல் இடப்பக்க மூலையில் குறிப்பிட்டு அவற்றை தயவுசெய்து “இல.366, நாவலை வீதி,  நாவலை, ராஜகிரிய“ என்ற முகவரிக்கு தபால் மூலம் அனுப்பவும் அனுப்பி வைக்கவும்.",
    //'If you wish to submit more supporting documents or evidence, please post them to "PPP Program Officer, Transparency International Sri Lanka, 5/1, Elibank Road, Colombo 05." mentioning the reference number on the top left corner of the document.',
    corruptionReport_step4DialogBoxDescriptionP3: "தயவுசெய்து காத்திருங்கள். இணைப்புகள் தரவேற்றப்படுகின்றன...",
    //"Please wait. Uploading Attachments...",
    corruptionReport_step4DialogBoxDescriptionP4: "இணைப்புகள் வெற்றிகரமாக தரவேற்றம் செய்யப்பட்டுள்ளன!",
    //"Attachments upload successful!",

    corruptionReport_step4DialogBoxButton: "சரி", //"Ok",

    //Report Election Form(Page) -----------------------------------------------

    //title
    electionReport_title: "தேர்தல் முறைகேடுகளை முறையிடுக", //"Report Election Violations",

    //stepper steps
    electionReport_stepperSteps:
        [
            "தனிப்பட்ட தகவல்கள்", //"Personal Information",
            "பொதுவான தகவல்கள்", //"General Information",
            "சமர்ப்பிக்கவும்", //"Submit",
        ],

    //stepper step 1 - form
    electionReport_step1_nameFieldTitle: "தயவுசெய்து உங்களது பெயரை பதிவிடுக", //"Please Enter Your Name",
    electionReport_step1_nameFieldPlaceholder: "பெயர்", //"Name",
    electionReport_step1_nameFieldError: "பெயர் அவசியம்", //"Name is required",

    electionReport_step1_ageFieldTitle: "தயவுசெய்து உங்களது வயதை பதிவிடுக", //"Please Select Your Age",
    electionReport_step1_ageFieldPlaceholder: "வயதை தெரிவு செய்க", //"Select Age",
    electionReport_step1_ageFieldError: "வயது அவசியம்", //"Age is required!",

    electionReport_step1_addressFieldTitle: "தயவுசெய்து உங்களது முகவரியை பதிவிடுக",
    //"Please Enter Your Address",
    electionReport_step1_addressFieldPlaceholder: "முகவரி", //"Address",
    electionReport_step1_addressFieldError: "முகவரி அவசியம்", //"Address is required!",

    electionReport_step1_contactNumberFieldTitle: "தயவுசெய்து உங்களது தொலைபேசி இலக்கத்தை பதிவிடுக",
    //"Please Enter Your Contact Number",
    electionReport_step1_contactNumberFieldPlaceholder: "தொலைபேசி இலக்கம்",
    //"Contact Number",
    electionReport_step1_contactNumberFieldError1: "தொலைபேசி இல அவசியம்",
    //"Contact Number is required!",
    electionReport_step1_contactNumberFieldError2: "தயவுசெய்து செல்லுபடியாகும் தொலைபேசி இலக்கத்தை பதிவிடுக",
    //"Please Enter valid Phone Number(Eg:0772345678)",

    electionReport_step1_emailFieldTitle: "தயவுசெய்து உங்களது மின்னஞ்சல் முகவரியை பதிவிடுக",
    //"Please Enter Your Email",
    electionReport_step1_emailFieldPlaceholder: "மின்னஞ்சல்", //"Email",
    electionReport_step1_emailFieldError1: "மின்னஞ்சல் அவசியம்",
    //"Email is required!",
    electionReport_step1_emailFieldError2: "தயவுசெய்து செல்லுபடியாகும் மின்னஞ்சல் முகவரியை பதிவிடுக",
    //"Please Enter valid Email!",

    electionReport_step1_genderFieldTitle: "பாலினத்தை தெரிவு செய்க", //"Select Gender",

    //buttons
    electionReport_step1_NextButton: "அடுத்து", //"Next",

    //stepper step 2 - form
    electionReport_step2_publicAuthorityInvolvedFieldTitle: "பொது நிர்வாகம் உள்ளடக்கப்பட்டுள்ளதா?",
    //"Public authority involved?",
    electionReport_step2_publicAuthorityInvolvedFieldAns1: "ஆம்", //"Yes",
    electionReport_step2_publicAuthorityInvolvedFieldAns2: "இல்லை", //"No",

    electionReport_step2_publicAuthorityFieldTitle: "தயவு செய்து சம்பந்தப்பட்ட அதிகாரசபையை தெரிவு செய்க",
    //"Please Select Authority Involved",
    electionReport_step2_publicAuthorityFieldPlaceholder: "அதிகாரசபையை தெரிவு செய்க",
    //"Select Authority",
    electionReport_step2_publicAuthorityFieldError: "அதிகார நிரல் அவசியம்",
    //"Authority field is required!",

    electionReport_step2_publicAuthorityDesignationFieldTitle: "தயவுசெய்து சம்பந்தப்பட்ட நபரின் பெயர் மற்றும் பதவியை பதிவிடுக",
    //"Please Enter Name and Designation of the Person Involved",
    electionReport_step2_publicAuthorityDesignationFieldPlaceholder: "சம்பவத்துடன் தொடர்புடைய நபரின் பெயரும் பதவியும்",
    //"Name and Designation of person involved",
    electionReport_step2_publicAuthorityDesignationFieldError: "பெயர் மற்றும் பதவி நிரல் அவசியம்",
    //"Name and Designation field is required!",

    electionReport_step2_incidentTypeFieldTitle: "தயவுசெய்து சம்பவத்தை தெரிவு செய்க",
    //"Please Select Incident",
    electionReport_step2_incidentTypeFieldPlaceholder: "சம்பவத்தின் நிலைமையை தெரிவு செய்க",
    //"Select Incident Type",
    electionReport_step2_incidentTypeFieldError: "சம்பவத்தின் வகை நிரல் அவசியம்",
    //"Incident Type field is required!",

    electionReport_step2_districtFieldTitle: "தயவுசெய்து மாவட்டத்தை தெரிவு செய்க",
    //"Please Select District",
    electionReport_step2_districtFieldPlaceholder: "மாவட்டத்தை தெரிவு செய்க", //"Select District",
    electionReport_step2_districtFieldError: "மாவட்ட நிரல் அவசியம்",
    //"District field is required!",

    electionReport_step2_divisionalSecretariatFieldTitle: "தயவுசெய்து பிரதேச செயலகத்தை தெரிவு செய்க",
    //"Please select Divisional Secretariat",
    electionReport_step2_divisionalSecretariatFieldPlaceholder: "பிரதேச செயலகத்தை தெரிவு செய்க",
    //"Select Divisional Secretariats",
    electionReport_step2_divisionalSecretariatFieldError: "பிரதேச செயலக நிரல் அவசியம்",
    //"Divisional Secretariats field is required!",

    electionReport_step2_dateFieldTitle: "தயவுசெய்து சம்பவ தினத்தை தெரிவு செய்க",
    //"Please Select Date of Incident",
    electionReport_step2_DateFieldError: "திகதி நிரல் அவசியம்",
    //"Date field is required!",

    electionReport_step2_timeFieldTitle: "தயவுசெய்து சம்பவ நேரத்தை தெரிவு செய்க",
    //"Please Select Time of Incident",
    electionReport_step2_TimeFieldError: "நேர நிரலை தெரிவு செய்க",
    //"Time field is required!",

    electionReport_step2_LocationMapField: "சுயமாக தேர்ந்தெடுக்கப்பட்ட இடம் தவறாக இருந்தால் அல்லது சம்பவத்தின் சரியான இடம் உங்களுக்குத் தெரிந்தால், தயவுசெய்து  கீழே உள்ள வரைபடத்தில் அதைத் தேர்ந்தெடுக்கவும்",
    //"If the automatically selected location is incorrect or if you know the exact location of the incident, please select it on the map below.",


    //buttons
    electionReport_step2_backButton: "பின்", //"Back",
    electionReport_step2_nextButton: "அடுத்து", //"Next",

    //stepper step 3 - form

    electionReport_step3_Title: "மேலும் பல பிரத்தியேக தகவல்கள்", //"More Specific Information",

    electionReport_step3_noteText: "Apesalli.lk தளமானது தேர்தலின் போது பொதுச் சொத்துக்கள்/வளங்கள் தவறாக பயன்படுத்தப்படுவதை மட்டுமே கண்காணிக்கின்றது.",
    //"Apesalli.lk only monitors misuse of public property/resources during elections",

    //form
    electionReport_step3_misusedFieldTitle: "இங்கு எது தவறாக பயன்படுத்தப்படுகிறது? கீழ் உள்ளவற்றில் ஒன்று அல்லது ஒன்றுக்கு மேற்பட்டவற்றை தெரிவு செய்க",
    //"What is being misused? Select one or more from below options.",

    //misused types
    lan_election_misusedTypes: [
        {
            key: 1,
            label: "தேர்தல் பிரச்சாரங்களுக்காக அரச வாகனங்களை பயன்படுத்தல்.",
            value: "Use of State Vehicles for Election Campaign Purposes ",
        },
        {
            key: 2,
            label: "தேர்தல் பிரச்சாரங்களுக்காக அரச கட்டிடங்கள், இடங்கள் மற்றும் காணிகளை பயன்படுத்தல்.",
            value: "Use of State Building & Premises/ Lands for Election Campaign Purposes ",
        },
        {
            key: 3,
            label: "தேர்தல் நோக்கில் வழங்கப்படும் நியமனங்கள் இடமாற்றங்கள் பதவி உயர்வுகள்.",
            value: "Appointments, Transfers & Promotions for State Officials targeting Election ",
        },
        {
            key: 4,
            label: "அரச அனுசரணையில் மேற்கொள்ளப்படும் அபிவிருத்தி நடவடிக்கைகளை தவறாக பயன்படுத்தல்.",
            value: "Misusing State sponsored Development Activities ",
        },
        {
            key: 5,
            label: "அரச உத்தியோகத்தர்கள் தம் கடமைகளை மீறி அரசியல் கட்சிகளுக்காக செயற்படல்.",
            value: "State Officers acting in favour of Political Parties & in Breach of Official Duties ",
        },
        {
            key: 6,
            label: "கொடுப்பனவுகளையும் பொருட்களையும் அரசியல் குறிக்கோளுக்காக வழங்குதல்.",
            value: "Giving Incentives/Equipment with Political Objectives ",
        },
        {
            key: 7,
            label: "அரச உத்தியோகத்தர்களையும் பாதுகாப்பு வளங்களையும் தேர்தல் பிரச்சாரத்திற்காக பயன்படுத்தல்.",
            value: "Use of State Officials & Security Resources for Election Campaign During the Period of an Election State Officers using Social Media for the Promotion of or in Prejudice to Any Party, Group or Candidate ",
        },
        {
            key: 8,
            label: "அரச ஊழியர்கள் ஓர் தனிநபரை, ஒரு குழுவை அல்லது எதாவது கட்சியினை ஊக்குவிப்பதற்காக அல்லது பாரபட்சமான வகையில் தகவல்களை பகிர சமூக ஊடகங்களை பயன்படுத்தல்",
            value: "During the Period of an Election State Officers using Social Media for the Promotion of or in Prejudice to Any Party, Group or Candidate ",
        },
        {
            key: 9,
            label: "அரசினால் வாழ்வாதாரத்திற்காக வழங்கப்படும் நிதிகளை தேர்தல் பிரச்சாரங்களுக்காகப் பயன்படுத்தல்.",
            value: "Manipulation of State sponsored Livelihood Grants & Allowances for Election Purposes ",
        },
        {
            key: 10,
            label: "அரச ஊடக நிறுவனங்களுக்கு சொந்தமான உபகரணங்கள் மற்றும் வளங்களை கட்டணம் செலுத்தாமல் பயன்படுத்தல்.",
            value: "Using Equipment and Facilities of State Media Institutions Without Paying ",
        },
        {
            key: 11,
            label: "திறப்பு விழாக்கள்/ அரச நிதியில் நடைபெறும் வைபவங்களில் கலந்துக்கொள்ளல்.",
            value: "Participating in Opening Ceremonies/ Government Funded Functions ",
        },
        {
            key: 12,
            label: "அரச வளங்களை பயன்படுத்தி நடைபெறக்கூடிய ஏனைய சட்ட விரோத தேர்தல் பிரச்சாரங்கள்.",
            value: "Other Illegal Election Campaigns Using State Resources ",
        },
    ],

    //misused nature types
    lng_misused_natureTypes: [
        {
            key: "misused_description_types 1",
            label: "சுவரொட்டிகளை ஒட்டுவதற்கு அரச வாகனங்களை பயன்படுத்தல்/ அரசியல் ரீதியான கூட்டங்களை அல்லது பேரணிகளை முன்னெடுத்தல் / வாக்காளர்களை அழைத்துச் செல்லல் மற்றும் அவ்வாறான தேர்தல் பிரச்சார நடவடிக்கைகள். ",
            //"Use of State Vehicles to put up posters/ organize political rallies and meetings/ transport voters and similar election related activities",
            value: "Use of State Vehicles to put up posters/ organize political rallies and meetings/ transport voters and similar election related activities",
        },
        {
            key: "misused_description_types 2",
            label: "தேர்தல் பிரச்சாரங்கள் மேற்கொள்ளல்/ தேர்தல் வேட்பாளர்களுக்கு மற்றும் அவர்களின் சுவரொட்டிகளை காட்சிப்படுத்த அலுவலகங்களை பயன்படுத்தல் போன்ற நடவடிக்கைகளுக்காக அரச கட்டிடங்கள், நிலப்பரப்பு மற்றும் காணிகளை கட்டணம் செலுத்தாமல் பயன்படுத்தல்.",
            //"Use of State buildings, premises or lands for election rallies/meetings, to maintain offices for election candidates and to display posters/cutouts without making the necessary payments ",
            value: "Use of State buildings, premises or lands for election rallies/meetings, to maintain offices for election candidates and to display posters/cutouts without making the necessary payments ",
        },
        {
            key: "misused_description_types 3",
            label: "தேர்தல் காலங்களில் விளையாட்டு உபகரணங்கள், விவசாய கருவிகள் மற்றும் ஏனைய சமூக நல உதவிகளை அரச நிதியிலிருந்து கொள்முதல் செய்தல் மற்றும் பகிர்ந்தளித்தல்.",
            //"Using State Funds to purchase and distribute sports equipment, agricultural equipment, and similar welfare aid during election times.",
            value: "Using State Funds to purchase and distribute sports equipment, agricultural equipment, and similar welfare aid during election times.",
        }
    ],

    //form fields
    electionReport_step3_natureOfMisuseFieldTitle: "தவறாக கையாளப்பட்ட விதத்தினை விபரிக்குக", //popup
    //"Describe the misuse",
    electionReport_step3_natureOfMisuseFieldPlaceholder: "தயவுசெய்து எவ்வாறு தவறாக கையாளப்பட்டது என்பதை விபரிக்கவும்",
    //"Please Describe Nature of Misuse",
    electionReport_step3_natureOfMisuseFieldError: "தவறின் பின்புல நிரல் அவசியம்",
    //"Nature of Misuse field is required",

    electionReport_step3_politicalPartyFieldTitle: "சம்பந்தப்பட்ட அரசியல் கட்சிகளின் தரவுகள்", //popup
    //"Details of the Political Party Involved:",
    electionReport_step3_politicalPartyFieldPlaceholder: "அரசியல் கட்சிகள் சம்பந்தப்பட்டிருத்தல் தொடர்பான தகவல்கள்.",
    //"Political Party Involved",

    //upload
    electionReport_step3_uploadButtonTitle1: "புகைப்பட ஆதாரங்களை பதிவேற்றல்", //"Upload Images",
    electionReport_step3_uploadButtonTitle2: "தெரிவு செய்யப்பட்ட ஆதாரங்கள்:", //"Selected:",

    electionReport_step3_trashButtonTooltip: "அகற்றவும்", //"Remove",

    //buttons
    electionReport_step3_finishButton: "முடிவு", //"Finish",

    //dialogBox
    electionReport_step3_DialogBoxTitle1: "ஊழலுக்கு எதிராக செயற்பட்டமைக்கு நன்றி!",
    //"Thankyou for standing against corruption !",
    electionReport_step3_DialogBoxTitle2: "உங்களது குறியீட்டு இலக்கம்", //"Your Reference Number is ",
    electionReport_step3_DialogBoxDescriptionP1: "உங்களது அறிக்கை வெற்றிகரமாக சமர்ப்பிக்கப்பட்டுள்ளது!",
    //"Your Report Submitted Successfully!.",
    electionReport_step3_DialogBoxDescriptionP2: "நீங்கள் இன்னும் பல ஆதாரங்கள் அல்லது ஆவணங்களை சமர்ப்பிக்க விரும்பினால் தயவுசெய்து அனாமதேய முறையில் 0112865777 என்ற இலக்கத்திற்கு ஆவணங்களை தொலைநகல் செய்யவும்",
    //"If you wish to submit more supporting documents or evidence, please Fax the documents anonymously to 0112865777.",
    electionReport_step3_DialogBoxButton: "சரி", //"Ok",

    //divisional secretariats

    lng_report_divisional_secretariats: [

        {
            key: 1,
            district: 'Kandy',
            divisional_secretariats: [
                { key: 1, value: 'Akurana', label: 'அக்குறணை', },
                { key: 2, value: 'Delthota', label: 'தெல்தோட்டை', },
                { key: 3, value: 'Doluwa', label: 'தொலுவ', },
                { key: 4, value: 'Gagawata Korale', label: 'ககாவட கோரளை', },
                { key: 5, value: 'Ganga Ihala Korale', label: 'கங்கா இஹல கோரளை', },
                { key: 6, value: 'Harispattuwa', label: 'ஹாரிஸ்பத்துவ', },
                { key: 7, value: 'Hatharaliyadda', label: 'ஹதரலியத்த', },
                { key: 8, value: 'Kundasale', label: 'குண்டசாலை', },
                { key: 9, value: 'Medadumbara', label: 'மெததும்பற', },
                { key: 10, value: 'Minipe', label: 'மினிப்பே', },
                { key: 11, value: 'Panvila', label: 'பன்வில', },
                { key: 12, value: 'Pasbage Korale', label: 'பஸ்பாகே கோரளை', },
                { key: 13, value: 'Pathadumbara', label: 'பததும்பற', },
                { key: 14, value: 'Pathahewaheta', label: 'பாதஹேவாஹெட்ட', },
                { key: 15, value: 'Poojapitiya', label: 'பூஜாபிடிய', },
                { key: 16, value: 'Thumpane', label: 'தும்பானே', },
                { key: 17, value: 'Udadumbara', label: 'உடதும்பற', },
                { key: 18, value: 'Udapalatha', label: 'உடபலாத்த', },
                { key: 19, value: 'Udunuwara', label: 'உடநுவர', },
                { key: 20, value: 'Yatinuwara', label: 'யட்டிநுவர', },
            ],

        },
        {
            key: 2,
            district: 'Matale',

            divisional_secretariats: [
                { key: 1, value: 'Ambanganga Korale', label: 'அம்பன்கங்க கோரளை', },
                { key: 2, value: 'Dambulla', label: 'தம்புள்ளை', },
                { key: 3, value: 'Galewela', label: 'கலேவெல', },
                { key: 4, value: 'Laggala-Pallegama', label: 'லக்கல-பல்லேகம', },
                { key: 5, value: 'Matale', label: 'மாத்தளை', },
                { key: 6, value: 'Naula', label: 'நாஹுல', },
                { key: 7, value: 'Pallepola', label: 'பல்லேபொல', },
                { key: 8, value: 'Rattota', label: 'இரத்தொட்டை', },
                { key: 9, value: 'Ukuwela', label: 'உக்குவெல', },
                { key: 10, value: 'Wilgamuwa', label: 'வில்கமுவ', },
                { key: 11, value: 'Yatawatta', label: 'யடவத்த', },
            ],

        },
        {
            key: 3,
            district: 'Nuwara Eliya',

            divisional_secretariats: [
                { key: 1, value: 'Ambagamuwa', label: 'அம்பகமுவ', },
                { key: 2, value: 'Hanguranketha', label: 'ஹங்குரான்கெத்த', },
                { key: 3, value: 'Kothmale', label: 'கொத்மலை', },
                { key: 4, value: 'Nuwara Eliya', label: 'நுவரேலியா', },
                { key: 5, value: 'Walapane', label: 'வலப்பனை', },
            ],

        },
        {
            key: 4,
            district: 'Ampara',

            divisional_secretariats: [
                { key: 1, value: 'Addalachchenai', label: 'அட்டாளைச்சேனை', },
                { key: 2, value: 'Akkaraipattu', label: 'அக்கரைப்பற்று', },
                { key: 3, value: 'Alayadiwembu', label: 'ஆலயடிவேம்பு', },
                { key: 4, value: 'Ampara', label: 'அம்பாறை', },
                { key: 5, value: 'Damana', label: 'தமண', },
                { key: 6, value: 'Dehiattakandiya', label: 'தெஹியத்தகண்டிய', },
                { key: 7, value: 'Eragama', label: 'இரக்காமம்', },
                { key: 8, value: 'Kalmunai Muslim', label: 'கல்முனை முஸ்லிம்', },
                { key: 9, value: 'Kalmunai Tamil', label: 'கல்முனை', },
                { key: 10, value: 'Karaitivu', label: 'காரைதீவு', },
                { key: 11, value: 'Lahugala', label: 'லாகுகல', },
                { key: 12, value: 'Mahaoya', label: 'மஹாஒயா', },
                { key: 13, value: 'Navithanveli', label: 'நாவிதன்வெளி', },
                { key: 14, value: 'Ninthavur', label: 'நிந்தாவூர்', },
                { key: 15, value: 'Padiyathalawa', label: 'பதியதலாவ', },
                { key: 16, value: 'Pothuvil', label: 'பொத்துவில்', },
                { key: 17, value: 'Sainthamarathu', label: 'சாய்ந்தமருது', },
                { key: 18, value: 'Samanthurai', label: 'சம்மாந்துறை', },
                { key: 19, value: 'Thirukkovil', label: 'திருக்கோவில்', },
                { key: 20, value: 'Uhana', label: 'உஹன', },
            ],

        },
        {
            key: 5,
            district: 'Batticaloa',

            divisional_secretariats: [
                { key: 1, value: 'Eravur Pattu', label: 'ஏறாவூர் பற்று', },
                { key: 2, value: 'Eravur Town', label: 'ஏறாவூர் நகர்', },
                { key: 3, value: 'Kattankudy', label: 'காத்தான்குடி', },
                { key: 4, value: 'Koralai Pattu', label: 'கோரளை பற்று', },
                { key: 5, value: 'Koralai Pattu Central', label: 'கோரளைபற்று மத்தி', },
                { key: 6, value: 'Koralai Pattu North', label: 'கோரளைபற்று வடக்கு', },
                { key: 7, value: 'Koralai Pattu South', label: 'கோரளைபற்று தெற்கு', },
                { key: 8, value: 'Koralai Pattu West', label: 'கோரளைபற்று மேற்கு', },
                { key: 9, value: 'Manmunai North', label: 'மண்முனை வடக்கு', },
                { key: 10, value: 'Manmunai Pattu', label: 'மண்முனைபற்று', },
                { key: 11, value: 'Manmunai S. and Eruvil Pattu', label: 'மண்முனை தெ. எருவில்பற்று', },
                { key: 12, value: 'Manmunai South West', label: 'மண்முனை தென்மேற்கு', },
                { key: 13, value: 'Manmunai West', label: 'மண்முனை மேற்கு', },
                { key: 14, value: 'Porativu Pattu', label: 'போரதீவுப்பற்று', },
            ],

        },
        {
            key: 6,
            district: 'Trincomalee',

            divisional_secretariats: [
                { key: 1, value: 'Gomarankadawala', label: 'கோமரன்கடவல', },
                { key: 2, value: 'Kantalai', label: 'கந்தளாய்', },
                { key: 3, value: 'Kinniya', label: 'கிண்ணியா', },
                { key: 4, value: 'Kuchchaveli', label: 'குச்சவெளி', },
                { key: 5, value: 'Morawewa', label: 'மொரவெவ', },
                { key: 6, value: 'Muttur', label: 'மூதூர்', },
                { key: 7, value: 'Padavi Sri Pura', label: 'பாதவி சிறிபுர', },
                { key: 8, value: 'Seruvila', label: 'சேருவில', },
                { key: 9, value: 'Thambalagamuwa', label: 'தம்பலகாமம்', },
                { key: 10, value: 'Trincomalee', label: 'திருகோணமலை', },
                { key: 11, value: 'Verugal', label: 'வெருகல்', },

            ],


        },
        {
            key: 7,
            district: 'Anuradhapura',

            divisional_secretariats: [
                { key: 1, value: 'Galnewa', label: 'கல்னேவ', },
                { key: 2, value: 'Galenbindunuwewa', label: 'கலென்பிந்துனுவேவ', },
                { key: 3, value: 'Horowpothana', label: 'ஹொறவ்பொத்தானை', },
                { key: 4, value: 'Ipalogama', label: 'இப்பலோகம', },
                { key: 5, value: 'Kahatagasdigiliya', label: 'கஹடகஸ்திகிலிய', },
                { key: 6, value: 'Kebithigollewa', label: 'கெப்பித்திகொல்லாவ', },
                { key: 7, value: 'Kekirawa', label: 'கெகிராவை', },
                { key: 8, value: 'Mahavilachchiya', label: 'மஹாவிலாச்சி', },
                { key: 9, value: 'Medawachchiya', label: 'மதவாச்சி', },
                { key: 10, value: 'Mihinthale', label: 'மிஹிந்தலை', },
                { key: 11, value: 'Nachchadoowa', label: 'நாச்சதுவ', },
                { key: 12, value: 'Nochchiyagama', label: 'நொச்சியாகம', },
                { key: 13, value: 'Nuwaragam Palatha Central', label: 'மத்திய நுவரகம்பலாத்த', },
                { key: 14, value: 'Nuwaragam Palatha East', label: 'கிழக்கு நுவரகம்பலாத்த', },
                { key: 15, value: 'Padaviya', label: 'பதவிய', },
                { key: 16, value: 'Palagala', label: 'பலேகல', },
                { key: 17, value: 'Palugaswewa', label: 'பலுகஸ்வெவ', },
                { key: 18, value: 'Rajanganaya', label: 'ராஜாங்கனை', },
                { key: 19, value: 'Rambewa', label: 'ரம்பேவ', },
                { key: 20, value: 'Thalawa', label: 'தலாவ', },
                { key: 21, value: 'Thambuttegama', label: 'தம்புத்தேகம', },
                { key: 22, value: 'Thirappane', label: 'திரப்பனை', },

            ],

        },
        {
            key: 8,
            district: 'Polonnaruwa',

            divisional_secretariats: [
                { key: 1, value: 'Dimbulagala', label: 'திம்புலாகல', },
                { key: 2, value: 'Elahera', label: 'எலஹெர', },
                { key: 3, value: 'Hingurakgoda', label: 'ஹிங்குறாக்கொட', },
                { key: 4, value: 'Lankapura', label: 'லங்காபுர', },
                { key: 5, value: 'Medirigiriya', label: 'மெதிரிகிரிய', },
                { key: 6, value: 'Thamankaduwa', label: 'மெதிரிகிரிய', },
                { key: 7, value: 'Welikanda', label: 'வெலிகந்தை', },

            ],

        },
        {
            key: 9,
            district: 'Jaffna',

            divisional_secretariats: [
                { key: 1, value: 'Delft', label: 'நெடுந்தீவு', },
                { key: 2, value: 'Island North', label: 'ஊர்காவற்துறை', },
                { key: 3, value: 'Island South', label: 'தீவகம் தெற்கு வேலணை', },
                { key: 4, value: 'Jaffna', label: 'யாழ்ப்பாணம்', },
                { key: 5, value: 'Karainagar', label: 'காரைநகர்', },
                { key: 6, value: 'Nallur', label: 'நல்லூர்', },
                { key: 7, value: 'Thenmaradchi', label: 'தென்மராட்சி', },
                { key: 8, value: 'Vadamaradchi East', label: 'வடமராட்சி கிழக்கு', },
                { key: 9, value: 'Vadamaradchi North', label: 'வடமராட்சி வடக்கு', },
                { key: 10, value: 'Vadamaradchi South-West', label: 'வடமராட்சி தென்மேற்கு', },
                { key: 11, value: 'Valikamam East', label: 'வலிகாமம் கிழக்கு', },
                { key: 12, value: 'Valikamam North', label: 'வலிகாமம் வடக்கு', },
                { key: 13, value: 'Valikamam South', label: 'வலிகாமம் தெற்கு', },
                { key: 14, value: 'Valikamam South-West', label: 'வலிகாமம் தென்மேற்கு', },
                { key: 15, value: 'Valikamam West', label: 'வலிகாமம் மேற்கு', },

            ],


        },
        {
            key: 10,
            district: 'Kilinochchi',

            divisional_secretariats: [
                { key: 1, value: 'Kandavalai', label: 'கண்டாவளை', },
                { key: 2, value: 'Karachchi', label: 'கரச்சி', },
                { key: 3, value: 'Pachchilaipalli', label: 'பச்சிலைப்பள்ளி', },
                { key: 4, value: 'Poonakary', label: 'பூநகரி', },

            ],

        },
        {
            key: 11,
            district: 'Mannar',

            divisional_secretariats: [
                { key: 1, value: 'Madhu', label: 'மடு', },
                { key: 2, value: 'Mannar', label: 'மன்னார்', },
                { key: 3, value: 'Manthai West', label: 'மாந்தை மேற்கு', },
                { key: 4, value: 'Musalai', label: 'முசலி', },
                { key: 5, value: 'Nanaddan', label: 'நானாட்டான்', },

            ],

        },
        {
            key: 12,
            district: 'Mullaitivu',

            divisional_secretariats: [
                { key: 1, value: 'Manthai East', label: 'மாந்தை கிழக்கு', },
                { key: 2, value: 'Maritimepattu', label: 'கரைதுறைப்பற்று', },
                { key: 3, value: 'Oddusuddan', label: 'ஒட்டிசுட்டான்', },
                { key: 4, value: 'Puthukudiyiruppu', label: 'புதுக்குடியிருப்பு', },
                { key: 5, value: 'Thunukkai', label: 'துணுக்காய்', },
                { key: 6, value: 'Welioya', label: 'மணலாறு', },

            ],

        },
        {
            key: 13,
            district: 'Vavuniya',

            divisional_secretariats: [
                { key: 1, value: 'Vavuniya', label: 'வவுனியா', },
                { key: 2, value: 'Vavuniya North', label: 'வவுனியா வடக்கு', },
                { key: 3, value: 'Vavuniya South', label: 'வவுனியா தெற்கு', },
                { key: 4, value: 'Vengalacheddikulam', label: 'வெங்கலசெட்டிக்குளம்', },

            ],


        },
        {
            key: 14,
            district: 'Kurunegala',

            divisional_secretariats: [
                { key: 1, value: 'Alawwa', label: 'அளவ்வ', },
                { key: 2, value: 'Ambanpola', label: 'அம்பன்பொல', },
                { key: 3, value: 'Bamunakotuwa', label: 'பமுனாகொட்டுவ', },
                { key: 4, value: 'Bingiriya', label: 'பிங்கிரிய', },
                { key: 5, value: 'Ehetuwewa', label: 'எஹடுவெவ', },
                { key: 6, value: 'Galgamuwa', label: 'கல்கமுவ', },
                { key: 7, value: 'Ganewatta', label: 'கனேவத்த', },
                { key: 8, value: 'Giribawa', label: 'கிரிபாவ', },
                { key: 9, value: 'Ibbagamuwa', label: 'இப்பாகமுவ', },
                { key: 10, value: 'Katupotha', label: 'கட்டுபொத', },

                { key: 11, value: 'Kobeigane', label: 'கொபெய்கனே', },
                { key: 12, value: 'Kotavehera', label: 'கொடவெஹர', },
                { key: 13, value: 'Kuliyapitiya East', label: 'குளியாப்பிடிய கிழக்கு', },
                { key: 14, value: 'Kuliyapitiya West', label: 'குளியாப்பிடிய மேற்கு', },
                { key: 15, value: 'Kurunegala', label: 'குருநாகல்', },
                { key: 16, value: 'Mahawa', label: 'மஹவ', },
                { key: 17, value: 'Mallawapitiya', label: 'மல்லவபிடிய', },
                { key: 18, value: 'Maspotha', label: 'மாஸ்பொத', },
                { key: 19, value: 'Mawathagama', label: 'மாவத்தகம', },
                { key: 20, value: 'Narammala', label: 'நாரம்மல', },

                { key: 21, value: 'Nikaweratiya', label: 'நிகவரடிய', },
                { key: 22, value: 'Panduwasnuwara', label: 'பண்டுவஸ்நுவர', },
                { key: 23, value: 'Pannala', label: 'பன்னல', },
                { key: 24, value: 'Polgahawela', label: 'பொல்கஹவெல', },
                { key: 25, value: 'Polpithigama', label: 'பொல்பிதிகம', },
                { key: 26, value: 'Rasnayakapura', label: 'ரஸ்னாயகபுர', },
                { key: 27, value: 'Rideegama', label: 'ரிதீகம', },
                { key: 28, value: 'Udubaddawa', label: 'உடுபத்தாவ', },
                { key: 29, value: 'Wariyapola', label: 'வாரியபொல', },
                { key: 30, value: 'Weerambugedara', label: 'வீரம்புகெதர', },

            ],

        },
        {
            key: 15,
            district: 'Puttalam',

            divisional_secretariats: [
                { key: 1, value: 'Anamaduwa', label: 'ஆனமடுவ', },
                { key: 2, value: 'Arachchikattuwa', label: 'ஆரச்சிகட்டுவ', },
                { key: 3, value: 'Chilaw', label: 'சிலாபம்', },
                { key: 4, value: 'Dankotuwa', label: 'தங்கொடுவ', },
                { key: 5, value: 'Kalpitiya', label: 'கல்பிட்டி', },
                { key: 6, value: 'Karuwalagaswewa', label: 'கருவலகஸ்வெவ', },
                { key: 7, value: 'Madampe', label: 'மாதம்பை', },
                { key: 8, value: 'Mahakumbukkadawala', label: 'மஹகும்புக்கடவல', },
                { key: 9, value: 'Mahawewa', label: 'மஹவெவ', },
                { key: 10, value: 'Mundalama', label: 'முந்தல்', },
                { key: 11, value: 'Nattandiya', label: 'நாத்தாண்டி', },
                { key: 12, value: 'Nawagattegama', label: 'நவகத்தேகம', },
                { key: 13, value: 'Pallama', label: 'பல்லம', },
                { key: 14, value: 'Puttalam', label: 'புத்தளம்', },
                { key: 15, value: 'Vanathavilluwa', label: 'வணாத்திவில்லு', },
                { key: 16, value: 'Wennappuwa', label: 'வென்னப்புவ', },

            ],

        },
        {
            key: 16,
            district: 'Kegalle',

            divisional_secretariats: [
                { key: 1, value: 'Aranayaka', label: 'அரநாயக்க', },
                { key: 2, value: 'Bulathkohupitiya', label: 'புலத்கொஹுபிடிய', },
                { key: 3, value: 'Dehiovita', label: 'தெஹிஓவிட', },
                { key: 4, value: 'Deraniyagala', label: 'தெரனியகல', },
                { key: 5, value: 'Galigamuwa', label: 'கலிகமுவ', },
                { key: 6, value: 'Kegalle', label: 'கேகாலை', },
                { key: 7, value: 'Mawanella', label: 'மாவனல்லை', },
                { key: 8, value: 'Rambukkana', label: 'ரம்புகனை', },
                { key: 9, value: 'Ruwanwella', label: 'ருவன்வெல்ல', },
                { key: 10, value: 'Warakapola', label: 'வரகாபொல', },
                { key: 11, value: 'Yatiyanthota', label: 'யட்டியான்தோட்டை', },

            ],

        },
        {
            key: 17,
            district: 'Ratnapura',

            divisional_secretariats: [
                { key: 1, value: 'Ayagama', label: 'அயகம', },
                { key: 2, value: 'Balangoda', label: 'பலாங்கொடை', },
                { key: 3, value: 'Eheliyagoda', label: 'எஹெலியகொட', },
                { key: 4, value: 'Elapattha', label: 'எலபத்த', },
                { key: 5, value: 'Embilipitiya', label: 'எம்பிலிபிடிய', },
                { key: 6, value: 'Godakawela', label: 'கொடகவெல', },

                { key: 7, value: 'Imbulpe', label: 'இம்புல்பே', },
                { key: 8, value: 'Kahawatta', label: 'கஹவத்த', },
                { key: 9, value: 'Kalawana', label: 'கலவான', },
                { key: 10, value: 'Kiriella', label: 'கிரிஎல்ல', },
                { key: 11, value: 'Kolonna', label: 'கொலன்ன', },
                { key: 12, value: 'Kuruvita', label: 'குருவிட்ட', },

                { key: 13, value: 'Nivithigala', label: 'நிவிதிகல', },
                { key: 14, value: 'Opanayaka', label: 'ஓபநாயக்க', },
                { key: 15, value: 'Pelmadulla', label: 'பெல்மடுள்ள', },
                { key: 16, value: 'Ratnapura', label: 'இரத்தினபுரி', },
                { key: 17, value: 'Weligepola', label: 'வெலிகெபொல', },
                // { key: 18, value: 'Pelmadulla',  label: 'பெல்மடுள்ள', },

            ],

        },
        {
            key: 18,
            district: 'Galle',

            divisional_secretariats: [
                { key: 1, value: 'Akmeemana', label: 'அக்மீமன', },
                { key: 2, value: 'Ambalangoda', label: 'அம்பலாங்கொடை', },
                { key: 3, value: 'Baddegama', label: 'பத்தேகம', },
                { key: 4, value: 'Balapitiya', label: 'பலபிட்டிய', },
                { key: 5, value: 'Benthota', label: 'பெந்தோட்டை', },
                { key: 6, value: 'Bope-Poddala', label: 'போப்பே போத்தலை', },
                { key: 7, value: 'Elpitiya', label: 'எல்பிட்டிய', },
                { key: 8, value: 'Galle', label: 'காலி', },
                { key: 9, value: 'Gonapinuwala', label: 'கோனாபினுவல', },
                { key: 10, value: 'Habaraduwa', label: 'ஹபராதுவ', },
                { key: 11, value: 'Hikkaduwa', label: 'ஹிக்கடுவ', },
                { key: 12, value: 'Imaduwa', label: 'இமாதுவ', },
                { key: 13, value: 'Karandeniya', label: 'கரந்தெனிய', },
                { key: 14, value: 'Nagoda', label: 'நாகொடை', },
                { key: 15, value: 'Neluwa', label: 'நெலுவ', },
                { key: 16, value: 'Niyagama', label: 'நியாகம', },
                { key: 17, value: 'Thawalama', label: 'தவலம', },
                { key: 18, value: 'Welivitiya-Divithura', label: 'வெலிவிட்டிய – திவிதுர', },
                { key: 19, value: 'Yakkalamulla', label: 'யக்கலமுல்லை', },

            ],
        },
        {
            key: 19,
            district: 'Hambantota',

            divisional_secretariats: [
                { key: 1, value: 'Ambalantota', label: 'அம்பலாந்தொட்ட', },
                { key: 2, value: 'Angunakolapelessa', label: 'அங்குனகொலபெலஸ்ஸ', },
                { key: 3, value: 'Beliatta', label: 'பெலியத்த', },
                { key: 4, value: 'Hambantota', label: 'ஹம்பாந்தோட்டை', },
                { key: 5, value: 'Katuwana', label: 'கடுவன', },
                { key: 6, value: 'Lunugamvehera', label: 'லுனுகம்வெஹர', },
                { key: 7, value: 'Okewela', label: 'ஒகேவெல', },
                { key: 8, value: 'Sooriyawewa', label: 'சூரியவெவ', },
                { key: 9, value: 'Tangalle', label: 'தங்கலை', },
                { key: 10, value: 'Thissamaharama', label: 'திஸ்ஸமஹாராம', },
                { key: 11, value: 'Walasmulla', label: 'வலஸ்முல்ல', },
                { key: 12, value: 'Weeraketiya', label: 'வீரகெட்டிய', },
            ],

        },
        {
            key: 20,
            district: 'Matara',

            divisional_secretariats: [
                { key: 1, value: 'Akuressa', label: 'அக்குரஸ்ஸ', },
                { key: 2, value: 'Athuraliya', label: 'அதுரலிய', },
                { key: 3, value: 'Devinuwara', label: 'தெவிநுவர', },
                { key: 4, value: 'Dickwella', label: 'திக்வெல்ல', },
                { key: 5, value: 'Hakmana', label: 'ஹக்மன', },
                { key: 6, value: 'Kamburupitiya', label: 'கம்புறுபிட்டிய', },
                { key: 7, value: 'Kirinda Puhulwella', label: 'கிரிந்த புஹுல்வெல', },
                { key: 8, value: 'Kotapola', label: 'கொட்டபொல', },
                { key: 9, value: 'Malimbada', label: 'மாலிம்பட', },
                { key: 10, value: 'Matara', label: 'மாத்தறை', },
                { key: 11, value: 'Mulatiyana', label: 'முலட்டியன', },
                { key: 12, value: 'Pasgoda', label: 'பஸ்கொட', },
                { key: 13, value: 'Pitabeddara', label: 'பிட்டபெத்தர', },
                { key: 14, value: 'Thihagoda', label: 'திஹகொட', },
                { key: 15, value: 'Weligama', label: 'வெலிகம', },
                { key: 16, value: 'Welipitiya', label: 'வெலிபிடிய', },
            ],

        },
        {
            key: 21,
            district: 'Badulla',

            divisional_secretariats: [
                { key: 1, value: 'Badulla', label: 'பதுளை', },
                { key: 2, value: 'Bandarawela', label: 'பண்டாரவளை', },
                { key: 3, value: 'Ella', label: 'எல்ல', },
                { key: 4, value: 'Haldummulla', label: 'ஹல்துமுல்ல', },
                { key: 5, value: 'Hali-Ela', label: 'ஹாலி-எல', },
                { key: 6, value: 'Haputale', label: 'ஹப்புதளை', },
                { key: 7, value: 'Kandaketiya', label: 'கந்தகெட்டிய', },
                { key: 8, value: 'Lunugala', label: 'லுனுகல', },
                { key: 9, value: 'Mahiyanganaya', label: 'மஹியங்கனை', },
                { key: 10, value: 'Meegahakivula', label: 'மீகஹகிவுல', },
                { key: 11, value: 'Passara', label: 'பஸ்ஸர', },
                { key: 12, value: 'Rideemaliyadda', label: 'ரிதிமாலியத்த', },
                { key: 13, value: 'Soranathota', label: 'சொரணாதோட்டை', },
                { key: 14, value: 'Uva-Paranagama', label: 'ஊவா-பரணகம', },
                { key: 15, value: 'Welimada', label: 'வெலிமட', },

            ],

        },
        {
            key: 22,
            district: 'Monaragala',

            divisional_secretariats: [
                { key: 1, value: 'Badalkumbura', label: 'படல்கும்புர', },
                { key: 2, value: 'Bibile', label: 'பிபில', },
                { key: 3, value: 'Buttala', label: 'புத்தள', },
                { key: 4, value: 'Katharagama', label: 'கதிர்காமம்', },
                { key: 5, value: 'Madulla', label: 'மடுள்ள', },
                { key: 6, value: 'Medagama', label: 'மெதகம', },
                { key: 7, value: 'Moneragala', label: 'மொனராகலை', },
                { key: 8, value: 'Sevanagala', label: 'செவனகல', },
                { key: 9, value: 'Siyambalanduwa', label: 'சியம்பலாண்டுவ', },
                { key: 10, value: 'Thanamalvila', label: 'தணமல்வில', },
                { key: 11, value: 'Wellawaya', label: 'வெல்லவாய', },
            ],

        },
        {
            key: 23,
            district: 'Colombo',

            divisional_secretariats: [
                { key: 1, value: 'Colombo', label: 'கொழும்பு', },
                { key: 2, value: 'Dehiwala', label: 'தெஹிவளை', },
                { key: 3, value: 'Homagama', label: 'ஹோமாகம', },
                { key: 4, value: 'Kaduwela', label: 'கடுவலை', },
                { key: 5, value: 'Kesbewa', label: 'கெஸ்பேவ', },
                { key: 6, value: 'Kolonnawa', label: 'கொலொன்னாவ', },
                { key: 7, value: 'Kotte', label: 'கோட்டை', },
                { key: 8, value: 'Maharagama', label: 'மஹரகம', },
                { key: 9, value: 'Moratuwa', label: 'மொறட்டுவை', },
                { key: 10, value: 'Padukka', label: 'பாதுக்கை', },
                { key: 11, value: 'Ratmalana', label: 'இரத்மலானை', },
                { key: 12, value: 'Seethawaka', label: 'சீதாவக்கை', },
                { key: 13, value: 'Thimbirigasyaya', label: 'திம்பிரிகஸ்யாய', },
            ],

        },
        {
            key: 24,
            district: 'Gampaha',

            divisional_secretariats: [
                { key: 1, value: 'Attanagalla', label: 'அத்தனகல்லை', },
                { key: 2, value: 'Biyagama', label: 'பியகம', },
                { key: 3, value: 'Divulapitiya', label: 'திவுலபிட்டிய', },
                { key: 3, value: 'Dompe', label: 'தொம்பே', },
                { key: 3, value: 'Gampaha', label: 'கம்பஹா', },
                { key: 3, value: 'Ja-Ela', label: 'ஜா-எல', },
                { key: 3, value: 'Katana', label: 'கடான', },
                { key: 3, value: 'Kelaniya', label: 'களனி', },
                { key: 3, value: 'Mahara', label: 'மஹர', },
                { key: 3, value: 'Minuwangoda', label: 'மினுவாங்கொடை', },
                { key: 3, value: 'Mirigama', label: 'மீரிகம', },
                { key: 3, value: 'Negombo', label: 'நீர்கொழும்பு', },
                { key: 3, value: 'Wattala', label: 'வத்தளை', },
            ],

        },
        {
            key: 25,
            district: 'Kalutara',

            divisional_secretariats: [
                { key: 1, value: 'Agalawatta', label: 'அகலவத்தை', },
                { key: 2, value: 'Bandaragama', label: 'பண்டாரகமை', },
                { key: 3, value: 'Beruwala', label: 'பேருவளை', },
                { key: 4, value: 'Bulathsinhala', label: 'புலத்சிங்ஹல', },
                { key: 5, value: 'Dodangoda', label: 'தொடங்கொட', },
                { key: 6, value: 'Horana', label: 'ஹொரன', },
                { key: 7, value: 'Ingiriya', label: 'இங்கிரிய', },
                { key: 8, value: 'Kalutara', label: 'களுத்துறை', },
                { key: 9, value: 'Madurawela', label: 'மதுரவெல', },
                { key: 10, value: 'Mathugama', label: 'மத்துகம', },
                { key: 11, value: 'Millaniya', label: 'மில்லனிய', },
                { key: 12, value: 'Palindanuwara', label: 'பாலிந்தநுவர', },
                { key: 13, value: 'Panadura', label: 'பாணந்துறை', },
                { key: 14, value: 'Walallavita', label: 'வலல்லாவிட்ட', },

            ],

        },

    ],

    //Reports Page - Home
    reportsPage_Title: "முறையீடுகள்", //'Reports',
    reportsPage_Button: "மேலும் வாசிக்க...", //'Read More...',

    //Stories Page - Home
    storiesPage_Title: "கதைகள்", //'Stories',
    storiesPage_Button: ", மேலும் வாசிக்க...", //'Read More...',

    storiesPage_authorityName: "அதிகாரப் பெயர்", //'Name of The Authority',
    storiesPage_personDesignation: "சம்பந்தப்பட்ட நபரின் பெயர் மற்றும் பதவி",
    //'Name and Designation of The Person Involved',
    storiesPage_district: "மாவட்டம்", //'District',
    storiesPage_divisionalSecratarient: "பிரதேச செயலகம்", //'Divisional Secretariat',
    storiesPage_IncidentDate: "சம்பவ தினம்", //'Incident Date',
    storiesPage_IncidentTime: "சம்பவ நேரம்", //'Incident Time',
    storiesPage_story: "கதை", //'Story - ',

    //Incident Single View Page - Home
    inidentSigleView_Main_TitleFirst: "சம்பவம்", //'Incident',
    inidentSigleView_Main_Title1: "கதை", //'Story',
    inidentSigleView_Main_Title2: "தேர்தல் முறைகேடு", //'Election Violation',
    inidentSigleView_published_date_Title: "வெளியிடப்பட்ட திகதி", //'Published on',

    inidentSigleView_BriberyAndSexualFavours_youAre: "நீங்கள் சம்பந்தப்பட்ட விதம்", //"You Involved As",
    inidentSigleView_Bribery_form: "இலஞ்சம் எங்கிருந்து ", //"Bribe From",
    inidentSigleView_Bribery_value: "பண மதிப்பு", //"Monetary Value",

    inidentSigleView_misuseFunds: "சொத்து வகை", //"Type of Property",

    inidentSigleView_misusePosition: "நன்மை", //"Benefit",

    inidentSigleView_conflict_field1: "தனியார் ஆர்வம்", //"Private Interest",
    inidentSigleView_conflict_field2: "ஆர்வத்தின் தன்மை", //"Nature Of Interest",
    inidentSigleView_conflict_field3: "ஆர்வத்தை வெளிப்படுத்துக", //"Disclose Interest",
    inidentSigleView_conflict_field4: "சம்பந்தப்பட்டுள்ளது", //"Involved",
    inidentSigleView_conflict_field5: "அங்கிகாரம் பெற்ற பங்கேற்பாளர்கள்", //"Authorized Participate",

    inidentSigleView_procurement_field: "கொள்முதல் வகை", //"Type of Procurement",

    inidentSigleView_election_field1: "தவறின் இயல்பு", //"Nature of Misuse",
    inidentSigleView_election_field2: "அரசியல் கட்சி", //"Political Party",
    inidentSigleView_election_field3: "எது தவறாக பயன்படுத்தப்பட்டது", //"What Is Being Misused?",

    inidentSigleView_otherDetails: "வேறு தகவல்கள்", //"Other Details",

    //other pages - search bar
    searchbar_placeholder: "தேடல்",

    //News Page - Home
    newsPage_Title: "செய்திகள்", //'News',
    newsPage_Button: "மேலும் வாசிக்க...", //'Read More...',
    newsPage_latestText: "சமீபத்திய செய்தி", //"Latest News",

    //News Single View Page - Home
    newsPage_published_Txt: "வெளியிடப்பட்டது", //'Published',
    newsPage_published_date_Title: "வெளியிடப்பட்ட திகதி ", //'Published on',
    newsPage_links_title: "மேலும் வாசிக்க அழுத்துக ...", //'Click to Read More...',

    statisticsPage_button1: "மொத்த சம்பவங்கள்", //"Total Incidents",

    statisticsPage_button2: "மேற்கொள்ளப்பட்ட நடவடிக்கைகள்", //"Action Taken",
    statisticsPage_button3: "மொத்த கதைகள்", //"Total Stories",
    statisticsPage_button4: "தேர்தல் வன்முறைகள்", //"Election Violations",

    statisticsPage_Chart_hoverText1: "சம்பவங்கள்", //"Incidents",

    statisticsPage_Chart_Tytpe1: "வரி வரைபடம்", //"Line View",
    statisticsPage_Chart_Tytpe2: "சட்ட வரைபடம்", //"Bar View",
    statisticsPage_Chart_Tytpe3: "Tiled View",

    statisticsPage_Chart_SaveImage: "படத்தை சேமிக்கவும்", //"Save Image",
    incidentsChart_noOfIncidents: "சம்பவங்கள்", //"Incident(s)",

    //Age wise Chart
    statisticsPage_AgeChart_Title: "சம்பவங்கள் - வயது அடிப்படையில்", //"Incidents Age Wise",
    statisticsPage_AgeChart_XAxis: "வயது", //"Age",

    //All incidents by category Chart
    statisticsPage_CategoryChart_Title: "சம்பவங்கள் வகைப்படுத்தலின் அடிப்படையில்", //"All Incidents by Category",
    statisticsPage_CategoryChartChart_hoverText: "சம்பவ வகை", //"Incident Type",
    incidentsChart_title: "வகைப்படுத்தலின் படி மொத்த சம்பவங்கள்", //"All Incidents by Category",
    incidentsChart_hoverText: "{a}<br/><strong>{b}</strong>: {c} சம்பவங்கள்",
    // "{a}<br/><strong>{b}</strong>: {c} Incidents",
    incidentsChart_bribery: "இலஞ்சம்", //"Bribery",
    incidentsChart_sexualFavours: "பாலியல் உதவி", //"Sexual Favours",
    incidentsChart_election: "", //"Election",
    incidentsChart_misuseOfProperty: "பொது நிதியையும் சொத்துக்களையும் தவறாக பயன்படுத்துதல் ",
    //"Misuse of Public Funds or Property",
    incidentsChart_misuseOfPosition: "பொதுப்பதவிகளை தவறாக பயன்படுத்தல்", //"Misuse of Public Position",
    incidentsChart_conflict: "எண்ணங்களில் மோதல்", //"Conflict of Interest",
    incidentsChart_procurement: "பொது கொள்முதல் முறைகேடுகள்", //"Public Procurement Irregularities",
    incidentsChart_other: "மற்றவை", //"Other",

    incidentsChart_askToContact: "தொடர்பு கொள்ள கேளுங்கள்", //"Ask to Contact",

    //year wise chart
    statisticsPage_YearChart_Title: "சம்பவங்கள் ஆண்டு வாரியாக", //"Incidents Year Wise",
    statisticsPage_YearChart_XAxis: "ஆண்டு", //"Year",

    //year Gender Wise chart
    statisticsPage_GenderChart_Title: "சம்பவங்கள் - பால்நிலை அடிப்படையில்", //"Incidents Gender Wise",
    statisticsPage_GenderChart_XAxis: "பால்நிலை", //"Gender",


    //Org Wise wise chart
    statisticsPage_OrgChart_Title: "சம்பவங்கள் - அதிகாரசபை அடிப்படையில்", //"All Incidents by Organization",
    statisticsPage_OrgChartChart_hoverText: "சம்பவ வகை", //"Incident Type",

    //District Wise wise chart
    statisticsPage_DistrictChart_Title: "சம்பவங்கள் - மாவட்ட அடிப்படையில்", //"All Incidents by District",
    designation_of_authority_validation_msg: "தயவுசெய்து 400 எழுத்துக்களுக்குக் குறைவான மதிப்பை உள்ளிடவும்.",
    nature_of_misuse_length_validation_msg: "தயவுசெய்து 800 எழுத்துக்களுக்குக் குறைவான மதிப்பை உள்ளிடவும்."
};
